<template>
    <div class="section-box" v-loading="loading">
        <div class="step" v-if="offerid&&serviceOffer.serviceType==2">
            <div class="lx_step" v-for="(item,index) in tabList" :key="index">
                <div class="img_mar" v-if="acttab==1&&offerid&&serviceOffer.serviceType==2">
                    <img src='../../assets/images/run_icon.png' v-if="acttab>index&&acttab<=tabList2.length">
                    <img src='../../assets/images/no_run_icon.png' v-else>
                </div>
                <div class="img_mar" v-else>
                    <img src='../../assets/images/run_icon.png' v-if="acttab>index+2&&acttab<=tabList2.length">
                    <img src='../../assets/images/no_run_icon.png' v-else>
                </div>
                <div :class="acttab>index&&acttab<=tabList2.length?'red':''"  v-if="acttab==1&&offerid&&serviceOffer.serviceType==2">{{item.name}}</div>
                <div :class="acttab>index+2&&acttab<=tabList2.length?'red':''" v-else>{{item.name}}</div>
                <div :class="acttab>index+3&&acttab<=tabList2.length?'line red2':' line'" v-if="tabList.length-index!=1"></div>
            </div>
        </div>
        <div class="step" v-else>
            <div class="lx_step" v-for="(item,index) in tabList" :key="index">
                <div class="img_mar" v-if="serviceOffer.serviceType==2&&acttab!=1">
                    <img src='../../assets/images/run_icon.png' v-if="acttab>index+2&&acttab<=tabList2.length">
                    <img src='../../assets/images/no_run_icon.png' v-else>
                </div>
                <div class="img_mar" v-else>
                    <img src='../../assets/images/run_icon.png' v-if="acttab>index&&acttab<=tabList2.length">
                    <img src='../../assets/images/no_run_icon.png' v-else>
                </div>
                <div :class="acttab>index+2&&acttab<=tabList2.length?'red':''" v-if="acttab!=1&&serviceOffer.serviceType==2">{{item.name}}</div>
                <div :class="acttab>index&&acttab<=tabList2.length?'red':''" v-else>{{item.name}}</div>
                <div :class="acttab>index+3&&acttab<=tabList2.length?'line red2':' line'" v-if="tabList.length-index!=1"></div>
            </div>
        </div>
        <div class="content">
            <div v-show="acttab==1">
                <el-form ref="form" :model="serviceOffer" label-width="145px" :rules="rules" class="el-our-class">
                    <el-form-item label="服务名称：" prop="serviceName">
                        <el-input v-model.trim="serviceOffer.serviceName" maxlength="50" placeholder="请输入服务名称" class="edit_input"></el-input>
                    </el-form-item>
                    <div class="flex">
                        <el-form-item label="领域名称：" prop="productDomainId">
                            <el-select v-model="serviceOffer.productDomainId" placeholder="请选择" disabled size="mini" filterable style="width: 550px;" @change="getdropList(1,serviceOffer.productDomainId,true)">
                                <el-option v-for="item in oneLevel" :key="item.id" :label="item.name" :value="item.id" style="width:540px">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="一级产品：" prop="oneProductId" class="mar-l-129">
                            <el-select v-model="serviceOffer.oneProductId" placeholder="请选择" size="mini" filterable style="width: 550px;" @change="getdropList(2,serviceOffer.oneProductId,true)">
                                <el-option v-for="item in twoLevel" :key="item.id" :label="item.name" :value="item.id" style="width:540px">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <el-form-item label="二级产品：" prop="twoProductId">
                            <el-select v-model="serviceOffer.twoProductId" placeholder="请选择" size="mini" filterable style="width: 550px;" @change="getdropList(3,serviceOffer.twoProductId,true)">
                                <el-option v-for="item in threeLevel" :key="item.id" :label="item.name" :value="item.id" style="width:540px">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="三级产品：" prop="threeProductId" class="mar-l-129">
                            <el-select v-model="serviceOffer.threeProductId" placeholder="请选择" size="mini" filterable style="width: 550px;">
                                <el-option v-for="item in fourLevel" :key="item.id" :label="item.name" :value="item.id" style="width:540px">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex">
                        <!-- @change="changeServeType()" -->
                        <el-form-item label="服务类型：" prop="serviceStageId">
                            <el-select v-model="serviceOffer.serviceStageId" placeholder="请选择" size="mini" filterable style="width: 550px;">
                                <el-option v-for="item in stageList" :key="item.id" :label="item.name" :value="item.id" style="width:540px">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="类别：" prop="serviceType" class="mar-l-129" required >
                            <el-select v-model="serviceOffer.serviceType" :disabled="categoryDisabled" placeholder="请选择" size="mini" filterable style="width: 550px;" @change="changeTyoenone()">
                                <el-option :value="1" label="标准服务"></el-option>
                                <el-option :value="2" label="项目服务"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="服务描述" prop="content" class="m-t-20">
                        <el-input type="textarea" v-model.trim="serviceOffer.content" maxlength="1000" placeholder="请输入备注，不超过1000字" class="edit_input" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" class="our-button" @click="nexttwo()">下一步</el-button>
                </div>
            </div>
            <div v-show="acttab==2||acttab==3" class="bill">
               <el-form ref="form2" :model="billData" label-width="130px">
                   <el-form-item label="结算方式：" prop="settleType">
                       <el-radio-group v-model="billData.settleType" :disabled="receivedis&&acttab==3" @click="changeCurentType(billData.settleType)">
                           <el-radio :label="0">按天结算</el-radio>
                           <el-radio :label="1">按小时结算</el-radio>
                       </el-radio-group>
                   </el-form-item>
                   <template v-if="billData.settleType==0">
                       <el-row :gutter="24">
                           <el-col :lg="12">
                               <el-form-item label="工作日价格：" prop="workdayPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.workdayPrice" @blur="regulartest('billData.workdayPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                           <el-col :lg="12" v-if="!receivedis">
                               <el-form-item label="工作日会员价：" prop="vipWorkdayPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.vipWorkdayPrice" @blur="regulartest('billData.vipWorkdayPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24">
                           <el-col :lg="12">
                               <el-form-item label="周末价格：" prop="weekendPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.weekendPrice" @blur="regulartest('billData.weekendPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                           <el-col :lg="12" v-if="!receivedis">
                               <el-form-item label="周末会员价：" prop="vipWeekendPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.vipWeekendPrice" @blur="regulartest('billData.vipWeekendPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24">
                           <el-col :lg="12">
                               <el-form-item label="节假日价格：" prop="holidayPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.holidayPrice" @blur="regulartest('billData.holidayPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                           <el-col :lg="12" v-if="!receivedis">
                               <el-form-item label="节假日会员价：" prop="vipHolidayPrice">
                                   <div class="d_flex">
                                       <el-input v-model.trim="billData.vipHolidayPrice" @blur="regulartest('billData.vipHolidayPrice')"></el-input>
                                       <div>元/天/人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                   </template>
                   <template v-if="billData.settleType==1">
                       <el-row :gutter="24">
                           <el-col :lg="24">
                               <el-form-item label="工作日价格：">
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input  v-model.trim="billConfiguration.workdayDepartHourPrice" @blur="regulartest('billConfiguration.workdayDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input v-model.trim="billConfiguration.workdayWorkHourPrice" @blur="regulartest('billConfiguration.workdayWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input v-model.trim="billConfiguration.workdayBackHourPrice" @blur="regulartest('billConfiguration.workdayBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24">
                           <el-col :lg="24">
                               <el-form-item label="周末价格：" >
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input v-model.trim="billConfiguration.weekendDepartHourPrice" @blur="regulartest('billConfiguration.weekendDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input v-model.trim="billConfiguration.weekendWorkHourPrice" @blur="regulartest('billConfiguration.weekendWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input v-model.trim="billConfiguration.weekendBackHourPrice" @blur="regulartest('billConfiguration.weekendBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24">
                           <el-col :lg="24">
                               <el-form-item label="节假日价格：" >
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input  v-model.trim="billConfiguration.holidayDepartHourPrice" @blur="regulartest('billConfiguration.holidayDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input  v-model.trim="billConfiguration.holidayWorkHourPrice" @blur="regulartest('billConfiguration.holidayWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input v-model.trim="billConfiguration.holidayBackHourPrice" @blur="regulartest('billConfiguration.holidayBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24" v-if="!receivedis">
                           <el-col :lg="24">
                               <el-form-item label="工作日会员价：" >
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input  v-model.trim="billConfiguration.vipWorkdayDepartHourPrice" @blur="regulartest('billConfiguration.vipWorkdayDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input  v-model.trim="billConfiguration.vipWorkdayWorkHourPrice" @blur="regulartest('billConfiguration.vipWorkdayWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input v-model.trim="billConfiguration.vipWorkdayBackHourPrice" @blur="regulartest('billConfiguration.vipWorkdayBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24" v-if="!receivedis">
                           <el-col :lg="24">
                               <el-form-item label="周末会员价：" >
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input v-model.trim="billConfiguration.vipWeekendDepartHourPrice" @blur="regulartest('billConfiguration.vipWeekendDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input  v-model.trim="billConfiguration.vipWeekendWorkHourPrice" @blur="regulartest('billConfiguration.vipWeekendWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input  v-model.trim="billConfiguration.vipWeekendBackHourPrice" @blur="regulartest('billConfiguration.vipWeekendBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                       <el-row :gutter="24" v-if="!receivedis">
                           <el-col :lg="24">
                               <el-form-item label="节假日会员价：" >
                                   <div class="d_flex">
                                       <div class="mar-r-22">出发</div>
                                       <el-input v-model.trim="billConfiguration.vipHolidayDepartHourPrice" @blur="regulartest('billConfiguration.vipHolidayDepartHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">工作</div>
                                       <el-input  v-model.trim="billConfiguration.vipHolidayWorkHourPrice" @blur="regulartest('billConfiguration.vipHolidayWorkHourPrice')"></el-input>
                                       <div class="mar-r-22">元 / 小时 / 人</div>
                                       <div class="mar-r-22">返程</div>
                                       <el-input  v-model.trim="billConfiguration.vipHolidayBackHourPrice" @blur="regulartest('billConfiguration.vipHolidayBackHourPrice')"></el-input>
                                       <div>元 / 小时 / 人</div>
                                   </div>
                               </el-form-item>
                           </el-col>
                       </el-row>
                   </template>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="工作日加班价格：" prop="isWorkdayHasOvertimeSetting">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.isWorkdayHasOvertimeSetting" class="mar-r-45"
                                                   @change="changeTime(billData.isWorkdayHasOvertimeSetting,'billData.workdayOverTimeBefore','billData.workdayOverTimeAfter')">
                                       <el-radio :label="false">无</el-radio>
                                       <el-radio :label="true">有</el-radio>
                                   </el-radio-group>
                                   <template v-if="billData.isWorkdayHasOvertimeSetting">
                                       <el-time-picker
                                               v-model="billData.workdayOverTimeBefore"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间"
                                       >
                                       </el-time-picker>
                                       <div class="mar-r-22">以前</div>
                                       <el-time-picker
                                               v-model="billData.workdayOverTimeAfter"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间">
                                       </el-time-picker>
                                       <div class="mar-r-40">以后</div>
                                       <div>加班价格：</div>
                                       <el-input v-model.trim="billData.workdayOverTimeHourPrice" @blur="regulartest('billData.workdayOverTimeHourPrice')"></el-input>
                                       <div>元/小时/人</div>
                                   </template>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="周末加班价格：" prop="isWeekendHasOvertimeSetting">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.isWeekendHasOvertimeSetting" class="mar-r-45"
                                        @change="changeTime(billData.isWeekendHasOvertimeSetting,'billData.weekendOverTimeBefore','billData.weekendOverTimeAfter')">
                                       <el-radio :label="false">无</el-radio>
                                       <el-radio :label="true">有</el-radio>
                                   </el-radio-group>
                                   <template v-if="billData.isWeekendHasOvertimeSetting">
                                       <el-time-picker
                                               v-model="billData.weekendOverTimeBefore"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间"
                                       >
                                       </el-time-picker>
                                       <div class="mar-r-22">以前</div>
                                       <el-time-picker
                                               v-model="billData.weekendOverTimeAfter"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间">
                                       </el-time-picker>
                                       <div class="mar-r-40">以后</div>
                                       <div>加班价格：</div>
                                       <el-input  v-model.trim="billData.weekendOverTimeHourPrice" @blur="regulartest('billData.weekendOverTimeHourPrice')"></el-input>
                                       <div>元/小时/人</div>
                                   </template>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="节假日加班价格：" prop="isHolidayHasOvertimeSetting">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.isHolidayHasOvertimeSetting" class="mar-r-45"
                                                   @change="changeTime(billData.isHolidayHasOvertimeSetting,'billData.holidayOverTimeBefore','billData.holidayOverTimeAfter')">
                                       <el-radio :label="false">无</el-radio>
                                       <el-radio :label="true">有</el-radio>
                                   </el-radio-group>
                                   <template v-if="billData.isHolidayHasOvertimeSetting">
                                       <el-time-picker
                                               v-model="billData.holidayOverTimeBefore"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间">
                                       </el-time-picker>
                                       <div class="mar-r-22">以前</div>
                                       <el-time-picker
                                               v-model="billData.holidayOverTimeAfter"
                                               value-format= "HH:mm:ss"
                                               placeholder="选择时间">
                                       </el-time-picker>
                                       <div class="mar-r-40">以后</div>
                                       <div>加班价格：</div>
                                       <el-input v-model.trim="billData.holidayOverTimeHourPrice" @blur="regulartest('billData.holidayOverTimeHourPrice')"></el-input>
                                       <div>元/小时/人</div>
                                   </template>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <template v-if="billData.settleType == 1">
                       <el-form-item label="扣除1小时价格：">
                           <div class="d_flex">
                               <el-radio-group v-model="billConfiguration.isDeductOneHourPrice" class="mar-r-45">
                                   <el-radio :label="true">是</el-radio>
                                   <el-radio :label="false">否</el-radio>
                               </el-radio-group>
                               <template v-if="billConfiguration.isDeductOneHourPrice">
                                   <el-time-picker
                                           v-model="billConfiguration.deductionOneHourBTime"
                                           value-format= "HH:mm"
                                           format= "HH:mm"
                                           placeholder="选择时间"
                                   >
                                   </el-time-picker>
                                   <div class="mar-r-22">~</div>
                                   <el-time-picker
                                           v-model="billConfiguration.deductionOneHourETime"
                                           value-format= "HH:mm"
                                           format= "HH:mm"
                                           placeholder="选择时间">
                                   </el-time-picker>
                               </template>
                           </div>
                       </el-form-item>
                   </template>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="同城补助：">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.citySubsidy" class="mar-r-45">
                                       <el-radio :label="1">无补助</el-radio>
                                       <el-radio :label="3">速派规则</el-radio>
                                       <el-radio :label="4">固定补助</el-radio>
                                   </el-radio-group>
                                   <template v-if="billData.citySubsidy==4">
                                       <el-input  v-model.trim="billData.cityFixedSubsidy" @blur="regulartest('billData.cityFixedSubsidy')"></el-input>
                                       <div>元/天/人</div>
                                   </template>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="异地补助：" prop="diffCitySubsidy">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.diffCitySubsidy" class="mar-r-45">
                                       <el-radio :label="1">无补助</el-radio>
                                       <el-radio :label="3">速派规则</el-radio>
                                       <el-radio :label="4">固定补助</el-radio>
                                   </el-radio-group>
                                   <template v-if="billData.diffCitySubsidy==4">
                                       <el-input v-model.trim="billData.diffCityFixedSubsidy" @blur="regulartest('billData.diffCityFixedSubsidy')"></el-input>
                                       <div>元/天/人</div>
                                   </template>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="发单方价格：" prop="isTaxIncluded">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.isTaxIncluded" class="mar-r-45">
                                       <el-radio :label="true">含税</el-radio>
                                       <el-radio :label="false">不含税</el-radio>
                                   </el-radio-group>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="特殊地区涨幅：" prop="specialPlaceIncreaseRate">
                               <div class="d_flex">
                                   <el-radio-group v-model="billData.Increase" class="mar-r-45">
                                       <el-radio :label="0">不涨</el-radio>
                                       <el-radio :label="1">增长</el-radio>
                                   </el-radio-group>
                                   <el-input  @blur="changeInput(billData.specialPlaceIncreaseRate,'billData.specialPlaceIncreaseRate')"
                                              v-model.number="billData.specialPlaceIncreaseRate" :disabled="billData.Increase==0"></el-input>
                                   <div>%</div>
                               </div>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-row :gutter="24">
                       <el-col :lg="24">
                           <el-form-item label="特殊地区：">
                                <span class="area-item" v-for="(item,index) in specialArea" :key="index">
                                    {{item.cityName || item.provinceName}}
                                    <i class="icon-remove" @click="removeDistrict(index)">×</i>
                                </span>
                               <span class="btn-add el-icon-plus" @click="isShowCascader=true"></span>
                           </el-form-item>
                       </el-col>
                   </el-row>
               </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" class="our-button" @click="stepOne()">上一步</el-button>
                    <el-button type="primary" class="our-button mar-l-43" @click="nextthree()">下一步</el-button>
                </div>
            </div>
            <div v-show="acttab==4" style="width: 1124px;">
                <div class="pos-absoulte">
                    <el-button size="mini" class="our-button2" @click="addinfo(1)">添加单选</el-button>
                    <el-button size="mini" class="our-button2" @click="addinfo(2)">添加多选</el-button>
                    <el-button size="mini" class="our-button2" @click="addinfo(3)">添加简答</el-button>
                </div>
                <div v-if="specialInfos" v-loading="specialloading">
                    <div class="special_content" v-for="(item,index) in specialInfos" :key="index" style="background: #F5F7F9;">
                        <div @click="deleteMaxIndex(index)"><i class="icon el-icon-close icon_close"></i></div>
                        <div class="single">
                            <div class="s-title">标题：</div>
                            <el-input  maxlength="100"  class="width_550" v-model="item.title"></el-input>
                            <el-checkbox v-model="item.isRequired" style=" line-height: 38px;">是否必选</el-checkbox>
                        </div>
                        <template>
                            <div class="single" v-if="item.problemType==1">
                                <el-radio-group v-model="item.rddiocurrentOption" @change="(val)=>changeRadio(val, index,item.rddiocurrentOption)">
                                    <el-radio v-for="(item2,index2) in item.problemOptions" :key="index2"  :label="item2.sortNo" >
                                        <el-input  maxlength="100" class="width_550" v-model="item2.content"></el-input>
                                        <div class="oper_con">
                                            <el-button @click.prevent="deleteIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1"><img src="../../assets/images/delete_icon.png"/></el-button>
                                            <el-button @click.prevent="upIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1&&index2!=0"><img src="../../assets/images/up_icon.png"/></el-button>
                                            <el-button @click.prevent="downIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1&&item.problemOptions.length-index2!=1"> <img src="../../assets/images/dowm_icon.png"/></el-button>
                                        </div>
                                    </el-radio>
                                </el-radio-group>
                            </div>
                            <div class="single" v-if="item.problemType==2">
                                <el-checkbox-group v-model="item.currentOption"  @change="(val)=>changecheckbox(val, index,item.currentOption)">
                                    <el-checkbox v-for="(item2,index2) in item.problemOptions" :key="index2" :label="item2.sortNo">
                                        <el-input  maxlength="100" class="width_550" v-model="item2.content"></el-input>
                                        <div class="oper_con">
                                            <el-button @click.prevent="deleteIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1"><img src="../../assets/images/delete_icon.png"/></el-button>
                                            <el-button @click.prevent="upIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1&&index2!=0"><img src="../../assets/images/up_icon.png"/></el-button>
                                            <el-button @click.prevent="downIndex(index,index2)" class="speiclButton" v-if="item.problemOptions.length>1&&item.problemOptions.length-index2!=1"> <img src="../../assets/images/dowm_icon.png"/></el-button>
                                        </div>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="single" v-if="item.problemType==3">
                                <el-input type="textarea" disabled maxlength="1000" ></el-input>
                            </div>
                        </template>
                        <div class="bottom_con" v-if="item.problemType!=3">
                            <div class="add_btn" @click="addsubject(index,item.problemOptions.length)">+</div>
                        </div>
                    </div>
                </div>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" class="our-button" @click="stepThree()">上一步</el-button>
                    <el-button type="primary" class="our-button mar-l-43" @click="nextfour()">下一步</el-button>
                </div>
            </div>
            <div v-show="acttab==5" style="width: 1124px;position: relative">
                <el-button size="mini" class="our-button2" style="position:relative;left:90%;" @click="addmodule">添加模块</el-button>
                <div v-for="(item,index) in confirmInfos" :key="index" class="mar-b-30">
                    <div class="subset">
                        <div class="subset-title font-20">模块名称：</div>
                        <el-input  maxlength="100" class="width_550" v-model="item.moduleName"></el-input>
                        <div class="subset-right">
                            <el-button size="mini" class="our-button3" @click="deletemodule(index)">删除模块</el-button>
                        </div>
                    </div>
                    <div class="special_content_max" v-if="item.subsets.length" style="top:0px">
                      <div class="subset2" v-for="(item2,index2) in item.subsets" :key="index2" style="background: #F5F7F9;">
                            <div class="flex">
                                <div class="subset-title">子集名称：</div>
                                <el-input  maxlength="100" class="width_550" v-model="item2.subsetName"></el-input>
                                <div class="oper_con max_move">
                                    <el-button class="speiclButton" v-if="item.subsets.length>1&&index2!=0" @click.prevent="MaxfwupIndex(index,index2)"><img src="../../assets/images/up_icon.png"/></el-button>
                                    <el-button class="speiclButton" v-if="item.subsets.length>1&&item.subsets.length-index2!=1" @click.prevent="MaxfwdownIndex(index,index2)"> <img src="../../assets/images/dowm_icon.png"/></el-button>
                                </div>
                                <div @click="fwdeleteMaxMaxIndex(index,index2)" class="sub-close"><i class="icon el-icon-close icon_close"></i></div>
                            </div>
                        <div class="zj-btn">
                            <el-button size="mini" class="our-button2" @click="fwaddinfo(1,index,index2)">+单选</el-button>
                            <el-button size="mini" class="our-button2" @click="fwaddinfo(2,index,index2)">+多选</el-button>
                            <el-button size="mini" class="our-button2" @click="fwaddinfo(3,index,index2)">+简答</el-button>
                        </div>
                          <div class="special_content" v-for="(item3,index3) in item2.subsetContents" :key="index3">
                              <div @click="fwdeleteMaxIndex(index,index2,index3)"><i class="icon el-icon-close icon_close max_icon_close"></i></div>
                              <div class="single">
                                  <div class="s-title">问题标题：</div>
                                  <el-input  maxlength="100"  class="width_550" v-model="item3.title"></el-input>
                              </div>
                              <template>
                                  <div class="single" v-if="item3.problemType==1">
                                      <el-radio-group v-model="item3.rddiocurrentOption" @input="(val)=>fwchangeRadio(val, index,index2,index3,item3.rddiocurrentOption)">
                                          <el-radio v-for="(item4,index4) in item3.problemOptions" :key="index4"  :label="item4.sortNo" >
                                              <el-input  maxlength="100" class="width_550" v-model="item4.content"></el-input>
                                              <div class="oper_con">
                                                  <el-button @click.prevent="fwdeleteIndex(index,index2,index3,index4)" class="speiclButton"  v-if="item3.problemOptions.length>1"><img src="../../assets/images/delete_icon.png"/></el-button>
                                                  <el-button @click.prevent="fwupIndex(index,index2,index3,index4)" class="speiclButton" v-if="item3.problemOptions.length>1&&index4!=0"><img src="../../assets/images/up_icon.png"/></el-button>
                                                  <el-button @click.prevent="fwdownIndex(index,index2,index3,index4)" class="speiclButton" v-if="item3.problemOptions.length>1&&item3.problemOptions.length-index4!=1"> <img src="../../assets/images/dowm_icon.png"/></el-button>
                                              </div>
                                          </el-radio>
                                      </el-radio-group>
                                  </div>
                                  <div class="single" v-if="item3.problemType==2">
                                      <el-checkbox-group v-model="item3.currentOption" @change="fwchangecheckbox(index,index2,index3,item3.currentOption)">
                                          <el-checkbox v-for="(item4,index4) in item3.problemOptions" :key="index4" :label="item4.sortNo">
                                              <el-input  maxlength="100" class="width_550" v-model="item4.content"></el-input>
                                              <div class="oper_con">
                                                  <el-button @click.prevent="fwdeleteIndex(index,index2,index3,index4)" class="speiclButton"  v-if="item3.problemOptions.length>1"><img src="../../assets/images/delete_icon.png"/></el-button>
                                                  <el-button @click.prevent="fwupIndex(index,index2,index3,index4)" class="speiclButton" v-if="item3.problemOptions.length>1&&index4!=0"><img src="../../assets/images/up_icon.png"/></el-button>
                                                  <el-button @click.prevent="fwdownIndex(index,index2,index3,index4)" class="speiclButton" v-if="item3.problemOptions.length>1&&item3.problemOptions.length-index4!=1"> <img src="../../assets/images/dowm_icon.png"/></el-button>
                                              </div>
                                          </el-checkbox>
                                      </el-checkbox-group>
                                  </div>
                                  <div class="single" v-if="item3.problemType==3">
                                      <el-input type="textarea" disabled maxlength="1000" ></el-input>
                                  </div>
                              </template>
                              <div class="bottom_con" v-if="item3.problemType!=3">
                                  <div class="add_btn" @click="fwaddsubject(index,index2,index3,item3.problemOptions.length)">+</div>
                              </div>
                          </div>
                    </div>
                    </div>
                    <div class="addZJ" @click="addZJ(index)">添加子集</div>
                </div>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" class="our-button" @click="stepFour()">上一步</el-button>
                    <el-button type="primary" class="our-button mar-l-43" @click="nextfive()">下一步</el-button>
                </div>
            </div>
            <div v-show="acttab==6">
                <template>
                    <el-form ref="form2" :model="matchConfig" label-width="120px">
                        <el-form-item label="证书要求：" prop="certificates">
                                    <span class="area-item" v-for="(item,index) in matchConfig.certificates"
                                          :key="index">
                                         {{item.certificateName}}
                                        <i class="icon-remove" @click="removecer(index)">×</i>
                                    </span>
                            <span class="btn-add el-icon-plus" @click="openaddCer()"></span>
                        </el-form-item>
                        <el-form-item label="服务标签：">
                            <el-select v-model="matchConfig.serviceLabelAuthType" placeholder="请选择" size="mini"
                                       filterable style="width: 250px;" class="mar-r-22">
                                <el-option :value="0" label="无认证"></el-option>
                                <el-option :value="1" label="速派初级认证"></el-option>
                                <el-option :value="2" label="速派中级认证"></el-option>
                                <el-option :value="3" label="速派高级认证"></el-option>
                            </el-select>
                            <el-select v-model="matchConfig.isServiceLabelPractical" placeholder="请选择"
                                       size="mini" filterable style="width: 250px;">
                                <el-option :value="0" label="无需实操认证"></el-option>
                                <el-option :value="1" label="需要实操认证"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品品牌标签：">
                            <el-select v-model="matchConfig.productBrandAuthType" placeholder="请选择" size="mini"
                                       filterable style="width: 250px;" class="mar-r-22">
                                <el-option :value="0" label="无认证"></el-option>
                                <el-option :value="1" label="速派初级认证"></el-option>
                                <el-option :value="2" label="速派中级认证"></el-option>
                                <el-option :value="3" label="速派高级认证"></el-option>
                            </el-select>
                            <el-select v-model="matchConfig.isProductBrandPractical" placeholder="请选择"
                                       size="mini" filterable style="width: 250px;" class="mar-r-22">
                                <el-option :value="0" label="无需实操认证"></el-option>
                                <el-option :value="1" label="需要实操认证"></el-option>
                            </el-select>
                            <el-select v-model="matchConfig.isOriginAuthRequired" placeholder="请选择"
                                       size="mini" filterable style="width: 250px;">
                                <el-option :value="0" label="无需原厂认证"></el-option>
                                <el-option :value="1" label="需原厂认证"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                        <el-button type="primary" class="our-button" @click="stepFive()">上一步</el-button>
                        <el-button type="primary" class="our-button mar-l-43" @click="confirmoffter()">确认</el-button>
                    </div>
                </template>

            </div>
        </div>
        <el-dialog
                width="500px"
                center
                :visible.sync="isShowCascader"
        >
            <el-form label-width="100">
                <el-form-item label="地址">
                    <el-cascader-panel
                            :options="province"
                            :props="options"
                            ref="cascader"
                            clearable>
                    </el-cascader-panel>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" @click="confirmDistrict">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog
                title="添加证书"
                width="500px"
                center
                :visible.sync="isShowCertificate"
        >
            <el-form ref="form3"  label-width="100" >
                <el-form-item label="选择证书">
                    <el-select v-model="CertificateTypes" placeholder="请选择" size="mini" filterable style="width: 250px;">
                        <el-option v-for="item in cerList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" @click="confirmCer()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getproSelect,selectStage,selectCerTypes,getSpecialAreas,addoffter,getoffterDetail,updateoffter,getSpecialAreaList} from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    import {mapActions} from "vuex";
    export default {
        name: "newServices",
        inject: ['reload'],
        data() {
            return {
                checkddd:[],
                specialloading:false,
                delTisp:'确定要删除吗？',
                loading:false,
                offerid:0,
                tabList:[
                    {id:1,name:'基本信息'},
                    {id:2,name:'发单方价格'},
                    {id:3,name:'接单方价格'},
                    {id:4,name:'特殊信息'},
                    {id:5,name:'服务确认'},
                    {id:6,name:'匹配机制'},
                ],
                tabList2:[
                    {id:1,name:'基本信息'},
                    {id:2,name:'发单方价格'},
                    {id:3,name:'接单方价格'},
                    {id:4,name:'特殊信息'},
                    {id:5,name:'服务确认'},
                    {id:6,name:'匹配机制'},
                ],
                active: 0,
                serviceOffer: {
                    serviceName:'',//必传
                    productDomainId:'',//领域id,必传
                    oneProductId: '',//一级产品id,必传
                    twoProductId: '',//二级级产品id,必传
                    threeProductId: '',//三级产品id
                    serviceStageId:'',//服务类型id,必传
                    serviceType: 1,//类别，1-标准，2-项目,必传
                    content:''//必传
                },
                categoryDisabled: false,
                acttab:1,
                rules: {
                    serviceName: [{required:true, message: '请输入服务名称！', trigger: 'blur'}],
                    productDomainId: [{required:true, message: '请选择领域名称！', trigger: 'blur'}],
                    oneProductId: [{required:true, message: '请选择所属一级产品！', trigger: 'blur'}],
                    twoProductId: [{required:true, message: '请选择所属二级产品！', trigger: 'blur'}],
                    threeProductId: [{required:true, message: '请选择所属三级产品！', trigger: 'blur'}],
                    serviceStageId: [{required:true, message: '请选择服务类型！', trigger: 'blur'}],
                    content: [{required:true, message: '请输入服务描述！', trigger: 'blur'}],
                },
                checkboxList: [],
                specialInfos: [],
                checkradio: {},
                fwcheckboxList: [],
                fwcheckradio: {},
                confirmInfos: [
                    // {
                    //     moduleName:'',
                    //     subsets:[]
                    // }
                ],
                //发单方
                billData:{
                    settleType:0,
                    workdayPrice:'', //工作日价格必填
                    vipWorkdayPrice:'',//vip工作日价格必填
                    weekendPrice:'',//周末价格必填
                    vipWeekendPrice:'',//vip周末价格必填
                    holidayPrice:'',//节假日价格必填
                    vipHolidayPrice:'',//vip节假日价格必填
                    isWorkdayHasOvertimeSetting:false,//是否工作日加班价格设置
                    workdayOverTimeBefore:'',//工作日加班计算什么时间前，isWorkdayHasOvertimeSetting=true必填
                    workdayOverTimeAfter:'',//工作日加班计算什么时间后，isWorkdayHasOvertimeSetting=true必填
                    workdayOverTimeHourPrice:'',//工作日加班价格，isWorkdayHasOvertimeSetting=true必填
                    isWeekendHasOvertimeSetting:false,//是否周末加班价格设置
                    weekendOverTimeBefore:'',//工作日加班计算什么时间前，isWeekendHasOvertimeSetting=true必填
                    weekendOverTimeAfter:'',//周末加班计算什么时间后，isWeekendHasOvertimeSetting=true必填
                    weekendOverTimeHourPrice:'',//周末加班价格，isWeekendHasOvertimeSetting=true必填
                    isHolidayHasOvertimeSetting:false,//是否节假日加班价格设置
                    holidayOverTimeBefore:'',//节假日加班计算什么时间前，isHolidayHasOvertimeSetting=true必填
                    holidayOverTimeAfter:'',//节假日加班计算什么时间后，isHolidayHasOvertimeSetting=true必填
                    holidayOverTimeHourPrice:'',//节假日加班价格，isHolidayHasOvertimeSetting=true必填,
                    citySubsidy:1,
                    diffCitySubsidy:1,
                    cityFixedSubsidy:'',
                    diffCityFixedSubsidy:'',
                    isTaxIncluded:true,
                    Increase:1,//涨幅
                    specialPlaceIncreaseRate:30,
                    specialPlace:[]
                },
                billConfiguration: {
                    workdayDepartHourPrice: '', //工作日小时 出发 价格，必填
                    workdayWorkHourPrice: '',//工作日小时 工作时价格，//必填
                    workdayBackHourPrice: '', //工作日小时 返回 价格，必填
                    vipWorkdayDepartHourPrice: '', //vip工作日小时 出发 价格，必填
                    vipWorkdayWorkHourPrice: '',//vip工作日小时 工作时价格，//必填
                    vipWorkdayBackHourPrice: '', //vip工作日小时 返回 价格，必填
                    weekendDepartHourPrice: '', //周末小时 出发 价格，必填
                    weekendWorkHourPrice: '',//周末小时 工作时价格，//必填
                    weekendBackHourPrice: '', //周末小时 返回 价格，必填
                    vipWeekendDepartHourPrice: '', //vip周末小时 出发 价格，必填
                    vipWeekendWorkHourPrice: '',//vip周末小时 工作时价格，//必填
                    vipWeekendBackHourPrice: '', //vip周末小时 返回 价格，必填
                    holidayDepartHourPrice: '', //节假日小时 出发 价格，必填
                    holidayWorkHourPrice: '',//节假日小时 工作时价格，//必填
                    holidayBackHourPrice: '', //节假日小时 返回 价格，必填
                    vipHolidayDepartHourPrice: '', //vip节假日小时 出发 价格，必填
                    vipHolidayWorkHourPrice: '',//vip节假日小时 工作时价格，//必填
                    vipHolidayBackHourPrice: '', //vip节假日小时 返回 价格，必填
                    isDeductOneHourPrice:false,//是否扣除1小时价格设置
                    deductionOneHourBTime:'',// 扣除1小时价格开始时间
                    deductionOneHourETime:''//扣除1小时价格终止时间
                },
                timeOption:{
                start: '06:00',
                step: '00:30',
                end: '20:00',
                },
                timeOption1:{
                    start: '06:00',
                    step: '00:30',
                    end: '20:00',
                },
                timeOption2:{
                    start: '06:00',
                    step: '00:30',
                    end: '20:00',
                },
                timeOption3:{
                    start: '06:00',
                    step: '00:30',
                    end: '20:00',
                },
                isShowCascader:false,
                province:[],//省列表
                options:{
                    // multiple: true, //多选
                    checkStrictly: true,//父子节点不相关联
                    emitPath:true,//返回各级节点组成的数组
                    lazy:true,
                    lazyLoad(node,resolve){
                        if(node.level==1){
                            //根据选择的省节点，加载市节点
                            getSpecialAreas(node.value).then(r=>{
                                // console.log(node);
                                if(r.Result==1){
                                    let list=r.Data ||[];
                                    list.map(item=>{
                                        item['label']=item.areaName;
                                        item['value']=item.aid;
                                        item['leaf']=true
                                    })
                                    resolve(list);
                                }else{
                                    resolve([])
                                }
                            })
                        }else{
                            resolve([])
                        }
                    }
                },
                specialArea:[],//特殊地区
                receivedis: true,
                // receivedis: false,
                // 基本信息
                oneLevel:[],
                twoLevel:[],
                threeLevel:[],
                fourLevel:[],
                stageList:[],
                curentType:0,
                //匹配机制
                matchConfig:{
                    serviceLabelAuthType:0,//服务标签认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isServiceLabelPractical:0,//服务标签是否需要实操认证 0-不需要，1-需要
                    productBrandAuthType:0,//产品品牌认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isProductBrandPractical:0,//产品品牌是否需要实操认证 0-不需要，1-需要
                    isOriginAuthRequired:0,
                    certificates:[]
                },
                CertificateTypes:'',
                isShowCertificate:false,
                cerList:[],
                isedit:0,//是否编辑状态
            }
        },
        methods:{
            ...mapActions('app', [
                'removeTabList'
            ]),
            changeCurentType(data){
                this.curentType = data;
            },
            regulartest(name) {
                let arr =name.split('.');
                // 限制只能输入数字
                let value = this[arr[0]][arr[1]].replace(/[^\d.]/g, '');
                // 限制第一个是数字不是小数点
                value = value.replace(/^\./g, "");
                // 限制只能出现一个小数点
                value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
                if(value>99999999.99){
                    this.$message.warning("最大值为99999999.99")
                    value = 99999999.99
                }
                // 重新赋值转换后的值
                this[arr[0]][arr[1]] = value;
            },
            changeTime(value,data1,data2){
                if(value){
                    let arr =data1.split('.');
                    let arr2 =data2.split('.');
                    this[arr[0]][arr[1]]='06:00:00';
                    this[arr2[0]][arr2[1]]='18:00:00'
                }
                // debugger
                // this["timeOption"+index]={
                //         start: value,
                //         step: '00:30',
                //         end: '20:00',
                // }
                // console.log(" this[\"timeOption\"+index]", this["timeOption"+index])
            },
            changeTyoenone(){
                if(this.serviceOffer.serviceType==2){
                    this.tabList=[
                        {id:1,name:'基本信息'},
                        {id:4,name:'特殊信息'},
                        {id:5,name:'服务确认'},
                        {id:6,name:'匹配机制'},
                    ]
                }else{
                    this.tabList=[
                        {id:1,name:'基本信息'},
                        {id:2,name:'发单方价格'},
                        {id:3,name:'接单方价格'},
                        {id:4,name:'特殊信息'},
                        {id:5,name:'服务确认'},
                        {id:6,name:'匹配机制'},
                    ]
                }
            },
            //基本信息
            selectStage(){
                let param={
                    firstProductId:this.serviceOffer.oneProductId,
                    productDomainId:this.serviceOffer.productDomainId
                }
                selectStage(param).then((res)=> {
                    if (res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.stageList=res.Data;
                })
            },
            getdropList(data,updata,status){
                // console.log(data,updata)
                let param={
                    levelType:data
                }
                if(data>0){
                    param.superiorId=updata
                }
                getproSelect(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    
                    if(data==0){
                        this.oneLevel=res.Data;
                        this.serviceOffer.productDomainId = this.oneLevel[0].id
                        this.getdropList(1,this.serviceOffer.productDomainId,false)
                        if(!this.offerid||status){
                            this.twoLevel=[];
                            this.threeLevel=[];
                            this.fourLevel = [];
                        }
                    }
                    if(data==1){
                        this.twoLevel=res.Data;
                        if(!this.offerid||status){
                            this.serviceOffer.oneProductId='';
                            this.serviceOffer.twoProductId='';
                            this.serviceOffer.threeProductId='';
                            this.threeLevel=[];
                            this.serviceOffer.serviceStageId='';
                            this.fourLevel = [];
                            this.stageList = [];
                        }
                    }
                    if(data==2){
                        this.threeLevel=res.Data;
                        if(!this.offerid||status){
                            this.serviceOffer.twoProductId='';
                            this.serviceOffer.threeProductId='';
                            this.serviceOffer.serviceStageId='';
                            this.selectStage();
                        }
                    }
                    if(data==3){
                        this.fourLevel=res.Data;
                        if(!this.offerid||status){
                            this.serviceOffer.threeProductId='';
                        }
                    }

                    if(updata == -1 && data == 2) {
                        this.categoryDisabled = true
                        this.serviceOffer.serviceType = 2
                        this.changeTyoenone()
                    }else{
                        if(updata != -1 && data == 2) {
                            this.categoryDisabled = false
                        }
                        // if(this.serviceOffer.serviceStageId == -1) {
                        //     this.categoryDisabled = true
                        //     this.serviceOffer.serviceType = 2
                        //     this.changeTyoenone()
                        // }else {
                        //     this.categoryDisabled = false
                        // }
                    }
                    // console.log("下拉",res.Data)
                })
            },
            // 点击三级产品
            thirdProduct(updata){
                if(updata == -1) {
                    this.categoryDisabled = true
                    this.serviceOffer.serviceType = 2
                    this.changeTyoenone()
                }else{
                    if(this.serviceOffer.serviceStageId == -1) {
                        this.categoryDisabled = true
                        this.serviceOffer.serviceType = 2
                        this.changeTyoenone()
                    }else {
                        this.categoryDisabled = false
                    }
                }
            },
            // 点击服务类型
            serviceType(updata) {
                if(updata == -1) {
                    this.categoryDisabled = true
                    this.serviceOffer.serviceType = 2
                    this.changeTyoenone()
                }else{
                    if(this.serviceOffer.twoProductId == -1 || 
                    this.serviceOffer.threeProductId == -1) {
                        this.categoryDisabled = true   
                        this.serviceOffer.serviceType = 2
                        this.changeTyoenone()
                    }else{
                        this.categoryDisabled = false
                    }
                }
            },
            //结束
            //特殊信息开始
            changecheckbox(val,index,currentOption){
                let arr = this.specialInfos[index].problemOptions;
                for(let i=0;i<arr.length;i++){
                    arr[i].isChecked=false;
                }
                currentOption.forEach(i2=>{
                    arr[i2-1].isChecked=true;
                })
                // debugger
                // const arr2=[];
                // for(let i2=0;i2<val.length;i2++){
                //     arr2.push(val[i2]);
                // }
                // this.checkboxList[sortNo]=arr2;
                // for(let i2=0;i2<arr2.length;i2++){
                //     console.log(arr2[i2])
                //     arr[arr2[i2]-1].isChecked=true;
                // }
                // console.log(" this.checkboxList", this.checkboxList)
                // console.log("arr",arr)
            },
            changeRadio(val,index,sort){
                let arr = this.specialInfos[index].problemOptions;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].sortNo == sort) {
                        arr[i].isChecked=true;
                    }else{
                        arr[i].isChecked=false;
                    }
                }
                // console.log(this.specialInfos[index].problemOptions)
                // this.checkradio = JSON.parse(JSON.stringify(this.checkradio))
                // console.log('-------obj',this.checkradio)
            },
            addsubject(index,mlength){
                this.specialInfos[index].problemOptions.push({
                        content: "",//必填
                        isChecked:false,
                        sortNo: mlength + 1//必填
                    }
                )
               // console.log(index,mlength)
            },
            deleteMaxIndex(index){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.specialloading=true;
                    this.specialInfos.splice(index,1);
                    let arr= this.specialInfos;
                    for(let i=0;i<arr.length;i++){
                        arr[i].sortNo=i+1;
                    }
                    // this.specialInfos=arr;
                    // for(let i=0;i<arr.length;i++) {
                    //     let arr2 =arr[i].problemOptions;
                    //     if(arr[i].problemType==1) {
                    //         this.checkradio['checkradio'+arr[i].sortNo]='';
                    //     }
                    //     if(arr[i].problemType==2) {
                    //         this.checkboxList[arr[i].sortNo]=[];
                    //     }
                    //     for(let i2=0;i2<arr2.length;i2++) {
                    //         if(arr2[i2].isChecked){
                    //             if(arr[i].problemType==2){
                    //                 this.checkboxList[arr[i].sortNo].push(arr2[i2].sortNo)
                    //             }
                    //             if(arr[i].problemType==1){
                    //                 this.checkradio['checkradio'+arr[i].sortNo]=arr2[i2].sortNo;
                    //             }
                    //
                    //         }
                    //     }
                    // }
                    setTimeout(()=>{
                        this.specialloading=false;
                    },300)
                })
                // console.log("删除最大后的数组",arr)
            },
            deleteIndex(index,index2){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.specialInfos[index].problemOptions.splice(index2,1);
                    let arr=this.specialInfos[index].problemOptions;
                    let arr2=[];
                    for(let i=0;i<arr.length;i++){
                        arr2.push( {
                            content:arr[i].content,//必填
                            isChecked:arr[i].isChecked,
                            sortNo:i+1//必填
                        })
                    }
                    this.specialInfos[index].problemOptions=arr2;
                    this.changeRadiocheck(arr2,index,this.specialInfos[index].problemType,this.specialInfos[index]);
                })
            },
            upIndex(index,index2){
                let arr = this.specialInfos[index].problemOptions;
                arr.splice(index2 - 1, 1, ...arr.splice(index2, 1, arr[index2 - 1]));
                // console.log("arr",arr)
                let arr2=this.specialInfos[index].problemOptions;
                let arr3=[];
                for(let i=0;i<arr2.length;i++){
                    arr3.push( {
                        content:arr2[i].content,//必填
                        isChecked:arr2[i].isChecked,
                        sortNo:i+1//必填
                    })
                }
                this.specialInfos[index].problemOptions=arr3;
                this.changeRadiocheck(arr3,index,this.specialInfos[index].problemType,this.specialInfos[index]);
                // console.log("上移后的数组",this.specialInfos[index].problemOptions)
            },
            changeRadiocheck(arr,index,problemType,arr2){
                if(problemType==1){
                    arr2.rddiocurrentOption='';
                    for(let i=0;i<arr.length;i++) {
                        if(arr[i].isChecked){
                            arr2.rddiocurrentOption = arr[i].sortNo;
                        }
                    }
                }
                if(problemType==2){
                    arr2.currentOption = [];
                    for(let i=0;i<arr.length;i++) {
                        if(arr[i].isChecked){
                            arr2.currentOption.push(arr[i].sortNo)
                        }
                    }
                }
            },
            changefwRadiocheck(arr,index,problemType,arr2){
                if(problemType==1){
                    arr2.rddiocurrentOption='';
                    for(let i=0;i<arr.length;i++) {
                        // debugger
                        if(arr[i].isChecked){
                            arr2.rddiocurrentOption=arr[i].sortNo;
                        }
                    }
                    // console.log(arr2.rddiocurrentOption)
                }
                if(problemType==2){
                    arr2.currentOption=[];
                    for(let i=0;i<arr.length;i++) {
                        if(arr[i].isChecked){
                            arr2.currentOption.push(arr[i].sortNo)
                        }
                    }
                }
            },
            downIndex(index,index2){
                let arr = this.specialInfos[index].problemOptions;
                arr.splice(index2, 1, ...arr.splice(index2 + 1, 1, arr[index2]));
                let arr2=this.specialInfos[index].problemOptions;
                let arr3=[];
                for(let i=0;i<arr2.length;i++){
                    arr3.push( {
                        content:arr2[i].content,//必填
                        isChecked:arr2[i].isChecked,
                        sortNo:i+1//必填
                    })
                }
                this.specialInfos[index].problemOptions=arr3;
                this.changeRadiocheck(arr3,index,this.specialInfos[index].problemType,this.specialInfos[index]);
                // console.log("下移后的数组",this.specialInfos[index].problemOptions)
            },
            addinfo(param){
                let arr =  this.specialInfos || [];
                // debugger
                if(param==1){
                    arr.push({
                        title:"",//必填
                        problemType:param,//必填	 1单选，2多选，3简答
                        isRequired:false,
                        sortNo:this.specialInfos?this.specialInfos.length+1:1,//序号
                        rddiocurrentOption:'',
                        problemOptions :[
                            {
                                content:"",//必填
                                isChecked:false,
                                sortNo:1//必填
                            }
                        ]
                    })
                }
                if(param==2){
                    arr.push({
                        title:"",//必填
                        problemType:param,//必填	 1单选，2多选，3简答
                        isRequired:false,
                        sortNo:this.specialInfos?this.specialInfos.length+1:1,//序号
                        currentOption:[],
                        rddiocurrentOption:'',
                        problemOptions :[
                            {
                                content:"",//必填
                                isChecked:false,
                                sortNo:1//必填
                            }
                        ]
                    })
                }
                if(param==3){
                    arr.push({
                        title:"",//必填
                        problemType:param,//必填	 1单选，2多选，3简答
                        isRequired:false,
                        sortNo:this.specialInfos?this.specialInfos.length+1:1,//序号
                        problemOptions :[
                            {
                                content:"",//必填
                                isChecked:false,
                                sortNo:1//必填
                            }
                        ]
                    })
                }
                // if(param==2){
                //     this.checkboxList[this.specialInfos.length]=[];
                // }
                // console.log(this.specialInfos)
            },
            stepThree(){
                let param = JSON.parse(window.localStorage.getItem('serviceOffer'));
                if(param.serviceType==1){
                    this.acttab=3;
                    let param=JSON.parse(window.localStorage.getItem('billData2'));
                    let param2=JSON.parse(window.localStorage.getItem('billConfiguration2'));
                    this.billData = param;
                    this.specialArea =param.specialPlace;
                    this.billConfiguration = param2;
                }else{
                    this.acttab=1;
                    let param=JSON.parse(window.localStorage.getItem('serviceOffer'));
                    this.serviceOffer = param;
                }

            },
            stepFour(){
                this.acttab=4;
                let param = JSON.parse(window.localStorage.getItem('specialInfos'));
                this.specialInfos = param || [];
            },
            nextfour(){
                if(this.specialInfos&&this.specialInfos.length>0){
                    const arr = this.specialInfos;
                    for(let i=0;i<arr.length;i++){
                        // if(arr[i].isRequired) {
                            if (!arr[i].title) {
                                this.$message.warning("请填写所有必填项")
                                return
                            }
                            if (arr[i].problemType != 3) {
                                const arr2 = arr[i].problemOptions;
                                for (let i2 = 0; i2 < arr2.length; i2++) {
                                    if (!arr2[i2].content) {
                                        this.$message.warning("请填写所有必填项")
                                        return
                                    }
                                }
                                // if(arr[i].problemType == 1 && arr[i].rddiocurrentOption == '') {
                                //     return this.$message.warning("请选择单选正确答案")
                                // }
                                // if(arr[i].problemType == 2 && !arr[i].currentOption.length) {
                                //     return this.$message.warning("请选择多选正确答案")
                                // }
                            }
                        // }
                    }
                    
                    window.localStorage.setItem('specialInfos',JSON.stringify(arr));
                    this.acttab=5;
                    // console.log('arr',arr)
                }else{
                    // this.$message.warning("特殊选项最少一个")
                    this.acttab=5;
                    window.localStorage.setItem('specialInfos',null);
                }
            },
            //特殊信息结束
            //服务确认
            addmodule(){
                this.confirmInfos.push({
                    moduleName: "",
                    subsets:[]
                })
            },
            deletemodule(index){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.confirmInfos.splice(index,1);
                })
            },
            addZJ(index){
                let arr = this.confirmInfos[index].subsets;
                arr.push({subsetName: "",subsetContents: []});
            },
            fwaddinfo(data,index,index2){
                let arr = this.confirmInfos[index].subsets[index2].subsetContents;
                if(data==1){
                    arr.push({
                        title: "",//必填
                        problemType: data,//必填     1单选，2多选，3简答
                        sortNo: arr.length + 1,//序号
                        rddiocurrentOption:'',
                        //问题明细，当problemType=3时非必填
                        problemOptions: [
                            {
                                content: "",//必填
                                isChecked: false,
                                sortNo: 1//必填
                            }
                        ]
                    })
                }
                if(data==2){
                    arr.push({
                        title: "",//必填
                        problemType: data,//必填     1单选，2多选，3简答
                        sortNo: arr.length + 1,//序号
                        currentOption:[],
                        //问题明细，当problemType=3时非必填
                        problemOptions: [
                            {
                                content: "",//必填
                                isChecked: false,
                                sortNo: 1//必填
                            }
                        ]
                    })
                }
                if(data==3){
                    arr.push({
                        title: "",//必填
                        problemType: data,//必填     1单选，2多选，3简答
                        sortNo: arr.length + 1,//序号
                        //问题明细，当problemType=3时非必填
                        problemOptions: [
                            {
                                content: "",//必填
                                isChecked: false,
                                sortNo: 1//必填
                            }
                        ]
                    })
                }
            },
            fwaddsubject(index,index2,index3,mlength){
                this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions.push({
                        content: "",//必填
                        isChecked:false,
                        sortNo: mlength + 1//必填
                    }
                )
            },
            fwdeleteIndex(index,index2,index3,index4){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions.splice(index4,1);
                    let arr=this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                    let arr2=[];
                    for(let i=0;i<arr.length;i++){
                        arr2.push( {
                            content:arr[i].content,//必填
                            isChecked:arr[i].isChecked,
                            sortNo:i+1//必填
                        })
                    }
                    this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions=arr2;
                    this.changefwRadiocheck(arr2,index3,this.confirmInfos[index].subsets[index2].subsetContents[index3].problemType,this.confirmInfos[index].subsets[index2].subsetContents[index3])
                })
            },
            /**
             * 数组调换位置
             */
            swapArray(arr, index1, index2) {
                arr[index1] = arr.splice(index2, 1, arr[index1])[0];
                return arr;
            },
            MaxfwupIndex(index,index2){
                let arr = this.confirmInfos[index].subsets;
                arr.splice(index2 - 1, 1, ...arr.splice(index2, 1, arr[index2 - 1]));
            },
            MaxfwdownIndex(index,index2){
                let arr = this.confirmInfos[index].subsets;
                arr.splice(index2, 1, ...arr.splice(index2 + 1, 1, arr[index2]));
            },
            fwupIndex(index,index2,index3,index4){
                let arr = this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                arr.splice(index4 - 1, 1, ...arr.splice(index4, 1, arr[index4 - 1]));
                let arr2=this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                let arr3 = [];
                for (let i = 0; i < arr2.length; i++) {
                    arr3.push({
                        content: arr2[i].content,//必填
                        isChecked: arr2[i].isChecked,
                        sortNo: i + 1//必填
                    })
                }
                this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions=arr3;
                this.changefwRadiocheck(arr3,index3,this.confirmInfos[index].subsets[index2].subsetContents[index3].problemType,this.confirmInfos[index].subsets[index2].subsetContents[index3])
                // console.log("上移后的数组",this.confirmInfos[index].subsetContents[index2].problemOptions)
            },
            fwdownIndex(index,index2,index3,index4){
                let arr =this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                arr.splice(index4, 1, ...arr.splice(index4 + 1, 1, arr[index4]));
                let arr2=this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                let arr3 = [];
                for (let i = 0; i < arr2.length; i++) {
                    arr3.push({
                        content: arr2[i].content,//必填
                        isChecked: arr2[i].isChecked,
                        sortNo: i + 1//必填
                    })
                }
                this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions=arr3;
                this.changefwRadiocheck(arr3,index3,this.confirmInfos[index].subsets[index2].subsetContents[index3].problemType,this.confirmInfos[index].subsets[index2].subsetContents[index3])
                // console.log("下移后的数组",this.confirmInfos[index].subsetContents[index2].problemOptions)
            },
            fwdeleteMaxIndex(index,index2,index3){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.confirmInfos[index].subsets[index2].subsetContents.splice(index3,1);
                    let arr = this.confirmInfos[index].subsets[index2].subsetContents;
                    for(let i=0;i<arr.length;i++){
                        arr[i].sortNo=i+1;
                    }
                })
                // console.log("删除后的数组",this.confirmInfos)
            },
            fwdeleteMaxMaxIndex(index,index2){
                this.$confirm(this.delTisp, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.confirmInfos[index].subsets.splice(index2,1);
                    let arr = this.confirmInfos[index].subsets;
                    for(let i=0;i<arr.length;i++){
                        arr[i].sortNo=i+1;
                    }
                })
                // console.log("删除后的数组",this.confirmInfos)
            },
            fwchangecheckbox(index,index2,index3,currentOption){
                let arr = this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                for(let i=0;i<arr.length;i++){
                    arr[i].isChecked=false;
                }
                currentOption.forEach(i2=>{
                    arr[i2-1].isChecked=true;
                })
                // console.log('problemOptions', this.confirmInfos[index].subsetContents[index2].problemOptions)
            },
            fwchangeRadio(val,index,index2,index3,sort){
                let arr = this.confirmInfos[index].subsets[index2].subsetContents[index3].problemOptions;
                for(let i=0;i<arr.length;i++){
                    if(arr[i].sortNo == sort) {
                        arr[i].isChecked=true;
                    }else{
                        arr[i].isChecked=false;
                    }
                }
            },
            nextfive(){
                if(this.confirmInfos&&this.confirmInfos.length>0){
                    let arr = this.confirmInfos;
                    for(let i=0;i<arr.length;i++){
                        if(arr[i].subsets.length<1){
                            this.$message.warning("子集最少一个")
                            return
                        }
                        let arr2=arr[i].subsets;
                        for(let i2=0;i2<arr2.length;i2++){
                            if(arr2[i2].subsetContents.length<1){
                                this.$message.warning("特殊选项最少一个")
                                return
                            }
                            if(!arr2[i2].subsetName){
                                this.$message.warning("请填写所有必填项")
                                return
                            }
                            let arr3=arr2[i2].subsetContents;
                            for(let i3=0;i3<arr3.length;i3++){
                                if(!arr3[i3].title){
                                    this.$message.warning("请填写所有必填项")
                                    return
                                }
                                if(arr3[i3].problemType!=3){
                                    let arr4 = arr3[i3].problemOptions;
                                    for(let i4=0;i4<arr4.length;i4++){
                                        if(!arr4[i4].content){
                                            this.$message.warning("请填写所有必填项")
                                            return
                                        }
                                    }
                                }
                            }
                        }

                    }
                    window.localStorage.setItem('confirmInfos',JSON.stringify(arr));
                    this.acttab=6;
                }else{
                    this.acttab=6;
                    // this.$message.warning("最少添加一个模块")
                }
            },
            //发单方
            reassign(){
                this.billData={
                        settleType:0,
                        workdayPrice:'', //工作日价格必填
                        vipWorkdayPrice:'',//vip工作日价格必填
                        weekendPrice:'',//周末价格必填
                        vipWeekendPrice:'',//vip周末价格必填
                        holidayPrice:'',//节假日价格必填
                        vipHolidayPrice:'',//vip节假日价格必填
                        isWorkdayHasOvertimeSetting:false,//是否工作日加班价格设置
                        workdayOverTimeBefore:'',//工作日加班计算什么时间前，isWorkdayHasOvertimeSetting=true必填
                        workdayOverTimeAfter:'',//工作日加班计算什么时间后，isWorkdayHasOvertimeSetting=true必填
                        workdayOverTimeHourPrice:'',//工作日加班价格，isWorkdayHasOvertimeSetting=true必填
                        isWeekendHasOvertimeSetting:false,//是否周末加班价格设置
                        weekendOverTimeBefore:'',//工作日加班计算什么时间前，isWeekendHasOvertimeSetting=true必填
                        weekendOverTimeAfter:'',//周末加班计算什么时间后，isWeekendHasOvertimeSetting=true必填
                        weekendOverTimeHourPrice:'',//周末加班价格，isWeekendHasOvertimeSetting=true必填
                        isHolidayHasOvertimeSetting:false,//是否节假日加班价格设置
                        holidayOverTimeBefore:'',//节假日加班计算什么时间前，isHolidayHasOvertimeSetting=true必填
                        holidayOverTimeAfter:'',//节假日加班计算什么时间后，isHolidayHasOvertimeSetting=true必填
                        holidayOverTimeHourPrice:'',//节假日加班价格，isHolidayHasOvertimeSetting=true必填,
                        citySubsidy:1,
                        diffCitySubsidy:1,
                        cityFixedSubsidy:'',
                        diffCityFixedSubsidy:'',
                        isTaxIncluded:true,
                        Increase:1,//涨幅
                        specialPlaceIncreaseRate:30,
                        specialPlace:[]
                };
                this.billConfiguration={
                        workdayDepartHourPrice: '', //工作日小时 出发 价格，必填
                        workdayWorkHourPrice: '',//工作日小时 工作时价格，//必填
                        workdayBackHourPrice: '', //工作日小时 返回 价格，必填
                        vipWorkdayDepartHourPrice: '', //vip工作日小时 出发 价格，必填
                        vipWorkdayWorkHourPrice: '',//vip工作日小时 工作时价格，//必填
                        vipWorkdayBackHourPrice: '', //vip工作日小时 返回 价格，必填
                        weekendDepartHourPrice: '', //周末小时 出发 价格，必填
                        weekendWorkHourPrice: '',//周末小时 工作时价格，//必填
                        weekendBackHourPrice: '', //周末小时 返回 价格，必填
                        vipWeekendDepartHourPrice: '', //vip周末小时 出发 价格，必填
                        vipWeekendWorkHourPrice: '',//vip周末小时 工作时价格，//必填
                        vipWeekendBackHourPrice: '', //vip周末小时 返回 价格，必填
                        holidayDepartHourPrice: '', //节假日小时 出发 价格，必填
                        holidayWorkHourPrice: '',//节假日小时 工作时价格，//必填
                        holidayBackHourPrice: '', //节假日小时 返回 价格，必填
                        vipHolidayDepartHourPrice: '', //vip节假日小时 出发 价格，必填
                        vipHolidayWorkHourPrice: '',//vip节假日小时 工作时价格，//必填
                        vipHolidayBackHourPrice: '', //vip节假日小时 返回 价格，必填
                        isDeductOneHourPrice:false,//是否扣除1小时价格设置
                        deductionOneHourBTime:'',// 扣除1小时价格开始时间
                        deductionOneHourETime:''//扣除1小时价格终止时间

                };
                this.specialArea=[];
            },
            changeInput(data,name) {
                let arr =name.split('.');
                let rate = 0;
                if (data<0){
                    rate=0;
                    this[arr[0]][arr[1]] = rate;
                    return
                }
                if(data>100){
                    rate=100;
                    this[arr[0]][arr[1]] = rate;
                    return
                }

                // var o = data.replace(/,/gi, '')
                // let rate = 1;
                // o = Number(o)
                // if (isNaN(o) || parseInt(o) < 1) {
                //     rate = 1;
                // } else if (parseInt(o) >= 100) {
                //     rate = 100;
                // } else {
                //     rate = Math.floor( o * 100) / 100
                // }
                // 重新赋值转换后的值
                this[arr[0]][arr[1]] = data;
            },
            nexttwo(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // console.log("serviceOffer",this.serviceOffer)
                        window.localStorage.setItem('serviceOffer',JSON.stringify(this.serviceOffer))
                        if(this.serviceOffer.serviceType==1){
                            this.acttab=2;
                        }else{
                            this.acttab=4;
                        }
                    }
                })
            },
            stepOne(){
                if(this.acttab==3){
                    if(this.isedit==1){
                        window.localStorage.setItem('billData2',JSON.stringify(this.billData))
                        window.localStorage.setItem('billConfiguration2',JSON.stringify(this.billConfiguration))
                    }
                    this.reassign();
                    this.acttab=2;
                    this.receivedis=true;
                    // this.receivedis=false;
                    let param=JSON.parse(window.localStorage.getItem('billData'));
                    let param2=JSON.parse(window.localStorage.getItem('billConfiguration'));
                    this.billData = param;
                    this.specialArea =param.specialPlace;
                    this.billConfiguration = param2;
                    this.curentType = param.settleType;
                }else{
                    this.acttab=1;
                    let param=JSON.parse(window.localStorage.getItem('serviceOffer'));
                    // console.log(param)
                    if(param){
                        this.serviceOffer=param;
                    }else{
                        this.serviceOffer= {
                            serviceName: '',//必传
                            productDomainId: '',//领域id,必传
                            oneProductId: '',//一级产品id,必传
                            twoProductId: '',//二级级产品id,必传
                            threeProductId: '',//三级产品id
                            serviceStageId: '',//服务类型id,必传
                            serviceType: 1,//类别，1-标准，2-项目,必传
                            content: ''//必传
                        }
                    }
                }

            },
            stepFive(){
                this.acttab=5;
                let param = JSON.parse(window.localStorage.getItem('confirmInfos'));
                this.confirmInfos = param || [];
            },
            confirmoffter(){
                let tips= '';
                if(this.isedit==1){
                    tips = '确认修改服务吗？'
                }else{
                    tips = '确认创建服务吗？'
                }
                this.$confirm(tips, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // if(!this.matchConfig.certificates.length){
                    //     this.$message.warning("请填写所有必填项")
                    //     return
                    // }
                    const serviceOffer = JSON.parse(window.localStorage.getItem('serviceOffer'));
                    const specialInfos = JSON.parse(window.localStorage.getItem('specialInfos'));
                    const confirmInfos = JSON.parse(window.localStorage.getItem('confirmInfos'));
                    const param = {
                        confirmInfos: confirmInfos || [],
                        matchConfig: this.matchConfig,
                        serviceOffer: serviceOffer,
                        specialInfos: specialInfos || [],
                        userId: getStorageUserRoleId(),
                    }
                    if (this.matchConfig.certificates&&!this.matchConfig.certificates.length) {
                        delete param.matchConfig.certificates
                    }
                    // !param.matchConfig.serviceLabelAuthType && delete param.matchConfig.serviceLabelAuthType
                    // !param.matchConfig.isServiceLabelPractical && delete param.matchConfig.isServiceLabelPractical
                    // !param.matchConfig.productBrandAuthType && delete param.matchConfig.productBrandAuthType
                    // !param.matchConfig.isProductBrandPractical && delete param.matchConfig.isProductBrandPractical
                    // !param.matchConfig.isOriginAuthRequired && delete param.matchConfig.isOriginAuthRequired
                    if (serviceOffer.serviceType == 1) {
                        const billData = JSON.parse(window.localStorage.getItem('billData'));
                        const billConfiguration = JSON.parse(window.localStorage.getItem('billConfiguration'));
                        const billData2 = JSON.parse(window.localStorage.getItem('billData2'));
                        const billConfiguration2 = JSON.parse(window.localStorage.getItem('billConfiguration2'));
                        //发单 每天
                        const billConfig = {
                            citySubsidy: billData.citySubsidy,
                            diffCitySubsidy: billData.diffCitySubsidy,
                            holidayPrice: billData.holidayPrice,
                            isHolidayHasOvertimeSetting: billData.isHolidayHasOvertimeSetting,
                            isTaxIncluded: billData.isTaxIncluded,
                            isWeekendHasOvertimeSetting: billData.isWeekendHasOvertimeSetting,
                            isWorkdayHasOvertimeSetting: billData.isWorkdayHasOvertimeSetting,
                            specialPlace: billData.specialPlace,
                            specialPlaceIncreaseRate: billData.specialPlaceIncreaseRate,
                            vipHolidayPrice: billData.vipHolidayPrice,
                            vipWeekendPrice: billData.vipWeekendPrice,
                            vipWorkdayPrice: billData.vipWorkdayPrice,
                            workdayPrice: billData.workdayPrice,
                            weekendPrice: billData.weekendPrice
                        }
                        //工作日加班
                        if (billData.isWorkdayHasOvertimeSetting) {
                            billConfig.workdayOverTimeBefore = billData.workdayOverTimeBefore;
                            billConfig.workdayOverTimeAfter = billData.workdayOverTimeAfter;
                            billConfig.workdayOverTimeHourPrice = billData.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if (billData.isWeekendHasOvertimeSetting) {
                            billConfig.weekendOverTimeBefore = billData.weekendOverTimeBefore;
                            billConfig.weekendOverTimeAfter = billData.weekendOverTimeAfter;
                            billConfig.weekendOverTimeHourPrice = billData.weekendOverTimeHourPrice;
                        }
                        if (billData.isHolidayHasOvertimeSetting) {
                            billConfig.holidayOverTimeBefore = billData.holidayOverTimeBefore;
                            billConfig.holidayOverTimeAfter = billData.holidayOverTimeAfter;
                            billConfig.holidayOverTimeHourPrice = billData.holidayOverTimeHourPrice;
                        }
                        if (billData.citySubsidy == 4) {
                            billConfig.cityFixedSubsidy = billData.cityFixedSubsidy;
                        }
                        if (billData.diffCitySubsidy == 4) {
                            billConfig.diffCityFixedSubsidy = billData.diffCityFixedSubsidy;
                        }
                        //接单 每天
                        const billConfig2 = {
                            citySubsidy: billData2.citySubsidy,
                            diffCitySubsidy: billData2.diffCitySubsidy,
                            holidayPrice: billData2.holidayPrice,
                            isHolidayHasOvertimeSetting: billData2.isHolidayHasOvertimeSetting,
                            isTaxIncluded: billData2.isTaxIncluded,
                            isWeekendHasOvertimeSetting: billData2.isWeekendHasOvertimeSetting,
                            isWorkdayHasOvertimeSetting: billData2.isWorkdayHasOvertimeSetting,
                            specialPlace: billData2.specialPlace,
                            specialPlaceIncreaseRate: billData2.specialPlaceIncreaseRate,
                            workdayPrice: billData2.workdayPrice,
                            weekendPrice: billData2.weekendPrice
                        }
                        if (billData2.isWorkdayHasOvertimeSetting) {
                            billConfig2.workdayOverTimeBefore = billData2.workdayOverTimeBefore;
                            billConfig2.workdayOverTimeAfter = billData2.workdayOverTimeAfter;
                            billConfig2.workdayOverTimeHourPrice = billData2.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if (billData2.isWeekendHasOvertimeSetting) {
                            billConfig2.weekendOverTimeBefore = billData2.weekendOverTimeBefore;
                            billConfig2.weekendOverTimeAfter = billData2.weekendOverTimeAfter;
                            billConfig2.weekendOverTimeHourPrice = billData2.weekendOverTimeHourPrice;
                        }
                        if (billData2.isHolidayHasOvertimeSetting) {
                            billConfig2.holidayOverTimeBefore = billData2.holidayOverTimeBefore;
                            billConfig2.holidayOverTimeAfter = billData2.holidayOverTimeAfter;
                            billConfig2.holidayOverTimeHourPrice = billData2.holidayOverTimeHourPrice;
                        }
                        if (billData2.citySubsidy == 4) {
                            billConfig2.cityFixedSubsidy = billData2.cityFixedSubsidy;
                        }
                        if (billData2.diffCitySubsidy == 4) {
                            billConfig2.diffCityFixedSubsidy = billData2.diffCityFixedSubsidy;
                        }
                        //发单 每小时
                        const hourlyfd = {
                            citySubsidy: billData.citySubsidy,
                            diffCitySubsidy: billData.diffCitySubsidy,
                            isHolidayHasOvertimeSetting: billData.isHolidayHasOvertimeSetting,
                            isTaxIncluded: billData.isTaxIncluded,
                            isWeekendHasOvertimeSetting: billData.isWeekendHasOvertimeSetting,
                            isWorkdayHasOvertimeSetting: billData.isWorkdayHasOvertimeSetting,
                            specialPlace: billData.specialPlace,
                            specialPlaceIncreaseRate: billData.specialPlaceIncreaseRate,
                            workdayDepartHourPrice: billConfiguration.workdayDepartHourPrice, //工作日小时 出发 价格，必填
                            workdayWorkHourPrice: billConfiguration.workdayWorkHourPrice,//工作日小时 工作时价格，//必填
                            workdayBackHourPrice: billConfiguration.workdayBackHourPrice, //工作日小时 返回 价格，必填
                            vipWorkdayDepartHourPrice: billConfiguration.vipWorkdayDepartHourPrice, //vip工作日小时 出发 价格，必填
                            vipWorkdayWorkHourPrice: billConfiguration.vipWorkdayWorkHourPrice,//vip工作日小时 工作时价格，//必填
                            vipWorkdayBackHourPrice: billConfiguration.vipWorkdayBackHourPrice, //vip工作日小时 返回 价格，必填
                            weekendDepartHourPrice: billConfiguration.weekendDepartHourPrice, //周末小时 出发 价格，必填
                            weekendWorkHourPrice: billConfiguration.weekendWorkHourPrice,//周末小时 工作时价格，//必填
                            weekendBackHourPrice: billConfiguration.weekendBackHourPrice, //周末小时 返回 价格，必填
                            vipWeekendDepartHourPrice: billConfiguration.vipWeekendDepartHourPrice, //vip周末小时 出发 价格，必填
                            vipWeekendWorkHourPrice: billConfiguration.vipWeekendWorkHourPrice,//vip周末小时 工作时价格，//必填
                            vipWeekendBackHourPrice: billConfiguration.vipWeekendBackHourPrice, //vip周末小时 返回 价格，必填
                            holidayDepartHourPrice: billConfiguration.holidayDepartHourPrice, //节假日小时 出发 价格，必填
                            holidayWorkHourPrice: billConfiguration.holidayWorkHourPrice,//节假日小时 工作时价格，//必填
                            holidayBackHourPrice: billConfiguration.holidayBackHourPrice, //节假日小时 返回 价格，必填
                            vipHolidayDepartHourPrice: billConfiguration.vipHolidayDepartHourPrice, //vip节假日小时 出发 价格，必填
                            vipHolidayWorkHourPrice: billConfiguration.vipHolidayWorkHourPrice,//vip节假日小时 工作时价格，//必填
                            vipHolidayBackHourPrice: billConfiguration.vipHolidayBackHourPrice, //vip节假日小时 返回 价格，必填
                            isDeductOneHourPrice: billConfiguration.isDeductOneHourPrice,
                        }
                        if (billConfiguration.isDeductOneHourPrice) {
                            hourlyfd.deductionOneHourBTime = billConfiguration.deductionOneHourBTime;
                            hourlyfd.deductionOneHourETime = billConfiguration.deductionOneHourETime;
                        }
                        //工作日加班
                        if (billData.isWorkdayHasOvertimeSetting) {
                            hourlyfd.workdayOverTimeBefore = billData.workdayOverTimeBefore;
                            hourlyfd.workdayOverTimeAfter = billData.workdayOverTimeAfter;
                            hourlyfd.workdayOverTimeHourPrice = billData.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if (billData.isWeekendHasOvertimeSetting) {
                            hourlyfd.weekendOverTimeBefore = billData.weekendOverTimeBefore;
                            hourlyfd.weekendOverTimeAfter = billData.weekendOverTimeAfter;
                            hourlyfd.weekendOverTimeHourPrice = billData.weekendOverTimeHourPrice;
                        }
                        if (billData.isHolidayHasOvertimeSetting) {
                            hourlyfd.holidayOverTimeBefore = billData.holidayOverTimeBefore;
                            hourlyfd.holidayOverTimeAfter = billData.holidayOverTimeAfter;
                            hourlyfd.holidayOverTimeHourPrice = billData.holidayOverTimeHourPrice;
                        }
                        if (billData.citySubsidy == 4) {
                            hourlyfd.cityFixedSubsidy = billData.cityFixedSubsidy;
                        }
                        if (billData.diffCitySubsidy == 4) {
                            hourlyfd.diffCityFixedSubsidy = billData.diffCityFixedSubsidy;
                        }
                        //接单 每小时
                        const jddata = {
                            citySubsidy: billData2.citySubsidy,
                            diffCitySubsidy: billData2.diffCitySubsidy,
                            isHolidayHasOvertimeSetting: billData2.isHolidayHasOvertimeSetting,
                            isTaxIncluded: billData2.isTaxIncluded,
                            isWeekendHasOvertimeSetting: billData2.isWeekendHasOvertimeSetting,
                            isWorkdayHasOvertimeSetting: billData2.isWorkdayHasOvertimeSetting,
                            specialPlace: billData2.specialPlace,
                            specialPlaceIncreaseRate: billData2.specialPlaceIncreaseRate,
                            workdayDepartHourPrice: billConfiguration2.workdayDepartHourPrice, //工作日小时 出发 价格，必填
                            workdayWorkHourPrice: billConfiguration2.workdayWorkHourPrice,//工作日小时 工作时价格，//必填
                            workdayBackHourPrice: billConfiguration2.workdayBackHourPrice, //工作日小时 返回 价格，必填
                            weekendDepartHourPrice: billConfiguration2.weekendDepartHourPrice, //周末小时 出发 价格，必填
                            weekendWorkHourPrice: billConfiguration2.weekendWorkHourPrice,//周末小时 工作时价格，//必填
                            weekendBackHourPrice: billConfiguration2.weekendBackHourPrice, //周末小时 返回 价格，必填
                            holidayDepartHourPrice: billConfiguration2.holidayDepartHourPrice, //节假日小时 出发 价格，必填
                            holidayWorkHourPrice: billConfiguration2.holidayWorkHourPrice,//节假日小时 工作时价格，//必填
                            holidayBackHourPrice: billConfiguration2.holidayBackHourPrice, //节假日小时 返回 价格，必填
                            isDeductOneHourPrice: billConfiguration2.isDeductOneHourPrice,
                        }
                        if (billConfiguration2.isDeductOneHourPrice) {
                            jddata.deductionOneHourBTime = billConfiguration2.deductionOneHourBTime;
                            jddata.deductionOneHourETime = billConfiguration2.deductionOneHourETime;
                        }
                        //工作日加班
                        if (billData2.isWorkdayHasOvertimeSetting) {
                            jddata.workdayOverTimeBefore = billData2.workdayOverTimeBefore;
                            jddata.workdayOverTimeAfter = billData2.workdayOverTimeAfter;
                            jddata.workdayOverTimeHourPrice = billData2.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if (billData2.isWeekendHasOvertimeSetting) {
                            jddata.weekendOverTimeBefore = billData2.weekendOverTimeBefore;
                            jddata.weekendOverTimeAfter = billData2.weekendOverTimeAfter;
                            jddata.weekendOverTimeHourPrice = billData2.weekendOverTimeHourPrice;
                        }
                        if (billData2.isHolidayHasOvertimeSetting) {
                            jddata.holidayOverTimeBefore = billData2.holidayOverTimeBefore;
                            jddata.holidayOverTimeAfter = billData2.holidayOverTimeAfter;
                            jddata.holidayOverTimeHourPrice = billData2.holidayOverTimeHourPrice;
                        }
                        if (billData2.citySubsidy == 4) {
                            jddata.cityFixedSubsidy = billData2.cityFixedSubsidy;
                        }
                        if (billData2.diffCitySubsidy == 4) {
                            jddata.diffCityFixedSubsidy = billData2.diffCityFixedSubsidy;
                        }
                        param.settleType = billData.settleType;
                        if (billData.settleType == 0) {
                            param.dailySettlement = {
                                billConfiguration: billConfig,
                                orderTakingConfiguration: billConfig2
                            }
                        } else {
                            param.hourlySettlement = {
                                billConfiguration: hourlyfd,
                                orderTakingConfiguration: jddata
                            }
                        }
                    }
                    // console.log('param',param)
                    if (this.offerid) {
                        this.newupdate(param);
                    } else {
                        this.newadd(param);
                    }
                })
                // console.log(this.matchConfig)
            },
            async newupdate(data){
                this.loading=true;
                let res = await updateoffter(data)
                // console.log(res)
                if(res.Result != 1) {
                    setTimeout(()=>{
                        this.loading=false;
                    },1000)
                    return this.$message.error(res.Message)
                }
                this.$message.success('修改成功')
                this.reassign();
                window.localStorage.removeItem('serviceOffer')
                window.localStorage.removeItem('specialInfos')
                window.localStorage.removeItem('confirmInfos')
                window.localStorage.removeItem('billData')
                window.localStorage.removeItem('billConfiguration')
                window.localStorage.removeItem('billData2')
                window.localStorage.removeItem('billConfiguration2')
                this.matchConfig={
                    serviceLabelAuthType: 0,//服务标签认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isServiceLabelPractical: 0,//服务标签是否需要实操认证 0-不需要，1-需要
                    productBrandAuthType: 0,//产品品牌认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isProductBrandPractical: 0,//产品品牌是否需要实操认证 0-不需要，1-需要
                    isOriginAuthRequired: 0,
                    certificates: []
                }
                setTimeout(()=>{
                    this.loading=false;
                },1000)
                this.acttab=1;
                setTimeout(() => {
                    this.removeTabList({
                        id: this.$route.meta.menuId,
                    })
                    this.$router.push({path:'/dataFrame/serviceDetails',query: {id:this.offerid}})
                }, 300)
            },
            async newadd(data){
                this.loading=true;
                let res = await addoffter(data)
                // console.log(res)
                if(res.Result != 1) {
                    setTimeout(()=>{
                        this.loading=false;
                    },1000)
                    return this.$message.error(res.Message)
                }
                this.$message.success('新增成功')
                this.reassign();
                window.localStorage.removeItem('serviceOffer')
                window.localStorage.removeItem('specialInfos')
                window.localStorage.removeItem('confirmInfos')
                window.localStorage.removeItem('billData')
                window.localStorage.removeItem('billConfiguration')
                window.localStorage.removeItem('billData2')
                window.localStorage.removeItem('billConfiguration2')
                this.matchConfig={
                    serviceLabelAuthType: 0,//服务标签认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isServiceLabelPractical: 0,//服务标签是否需要实操认证 0-不需要，1-需要
                    productBrandAuthType: 0,//产品品牌认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isProductBrandPractical: 0,//产品品牌是否需要实操认证 0-不需要，1-需要
                    isOriginAuthRequired: 0,
                    certificates: []
                }
                setTimeout(()=>{
                    this.loading=false;
                },1000)
                this.acttab=1;
                setTimeout(() => {
                    this.removeTabList({
                        id: this.$route.meta.menuId,
                    })
                    this.$router.push('/dataFrame/serviceLibrary');
                }, 300)
            },
            nextthree(){
                if(this.billData.settleType==0){
                    if(!this.receivedis){
                        if(this.billData.workdayPrice===""||this.billData.vipWorkdayPrice===""||this.billData.weekendPrice===""||
                            this.billData.vipWeekendPrice===""||this.billData.holidayPrice===""||this.billData.vipHolidayPrice===""){
                            this.$message.warning("请填写所有必填项")
                            return
                        }
                    }else{
                        if(this.billData.workdayPrice===""||this.billData.weekendPrice===""||this.billData.holidayPrice===""){
                            this.$message.warning("请填写所有必填项")
                            return
                        }
                    }
                }else{
                    if(!this.receivedis){
                        if(this.billConfiguration.workdayDepartHourPrice===""||this.billConfiguration.workdayWorkHourPrice===""||this.billConfiguration.workdayBackHourPrice===""||
                            this.billConfiguration.vipWorkdayDepartHourPrice===""||this.billConfiguration.vipWorkdayWorkHourPrice===""||this.billConfiguration.vipWorkdayBackHourPrice===""||
                            this.billConfiguration.weekendDepartHourPrice===""||this.billConfiguration.weekendWorkHourPrice===""||this.billConfiguration.weekendBackHourPrice===""||
                            this.billConfiguration.vipWeekendDepartHourPrice===""||this.billConfiguration.vipWeekendWorkHourPrice===""||this.billConfiguration.vipWeekendBackHourPrice===""||
                            this.billConfiguration.holidayDepartHourPrice===""||this.billConfiguration.holidayWorkHourPrice===""||this.billConfiguration.holidayBackHourPrice===""||
                            this.billConfiguration.vipHolidayDepartHourPrice===""||this.billConfiguration.vipHolidayWorkHourPrice===""||this.billConfiguration.vipHolidayBackHourPrice===""){
                            this.$message.warning("请填写所有必填项")
                            return
                        }
                    }else{
                        if(this.billConfiguration.workdayDepartHourPrice===""||this.billConfiguration.workdayWorkHourPrice===""||this.billConfiguration.workdayBackHourPrice===""||
                            this.billConfiguration.weekendDepartHourPrice===""||this.billConfiguration.weekendWorkHourPrice===""||this.billConfiguration.weekendBackHourPrice===""||
                            this.billConfiguration.holidayDepartHourPrice===""||this.billConfiguration.holidayWorkHourPrice===""||this.billConfiguration.holidayBackHourPrice===""){
                            this.$message.warning("请填写所有必填项")
                            return
                        }
                    }
                }
                if(this.billData.isWorkdayHasOvertimeSetting){
                    if(this.billData.workdayOverTimeBefore===""||this.billData.workdayOverTimeAfter===""||this.billData.workdayOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.billData.isWeekendHasOvertimeSetting){
                    if(this.billData.weekendOverTimeBefore===""||this.billData.weekendOverTimeAfter===""||this.billData.weekendOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.billData.isHolidayHasOvertimeSetting){
                    if(this.billData.holidayOverTimeBefore===""||this.billData.holidayOverTimeAfter===""||this.billData.holidayOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.billData.citySubsidy==4){
                    if(this.billData.cityFixedSubsidy===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.billData.diffCitySubsidy==4){
                    if(this.billData.diffCityFixedSubsidy===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.billData.Increase==1){
                    if(this.billData.specialPlaceIncreaseRate===''){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(!this.specialArea.length){
                        this.$message.warning("请填写所有必填项")
                        return
                    }else{
                        this.billData.specialPlace=this.specialArea;
                    }
                }
                if(this.acttab==2){
                    this.receivedis=true;
                    this.acttab=3;
                    let param = this.billData.settleType;
                    window.localStorage.setItem('billData',JSON.stringify(this.billData))
                    window.localStorage.setItem('billConfiguration',JSON.stringify(this.billConfiguration))
                    this.reassign();
                    if(this.offerid) {
                        let jddata = JSON.parse(window.localStorage.getItem('jddata'));
                        if(param==0){
                            console.log(jddata)
                            // 按天 接单
                            this.billData.citySubsidy = jddata.citySubsidy;
                            this.billData.diffCitySubsidy = jddata.diffCitySubsidy;
                            this.billData.holidayPrice = jddata.holidayPrice;
                            this.billData.isHolidayHasOvertimeSetting = jddata.isHolidayHasOvertimeSetting;
                            this.billData.isTaxIncluded = jddata.isTaxIncluded;
                            this.billData.isWeekendHasOvertimeSetting = jddata.isWeekendHasOvertimeSetting;
                            this.billData.isWorkdayHasOvertimeSetting = jddata.isWorkdayHasOvertimeSetting;
                            this.billData.specialPlace = jddata.specialPlace;
                            this.billData.specialPlaceIncreaseRate = jddata.specialPlaceIncreaseRate;
                            this.billData.vipHolidayPrice = jddata.vipHolidayPrice;
                            this.billData.vipWeekendPrice = jddata.vipWeekendPrice;
                            this.billData.vipWorkdayPrice = jddata.vipWorkdayPrice;
                            this.billData.workdayPrice = jddata.workdayPrice;
                            this.billData.weekendPrice = jddata.weekendPrice;
                            if(jddata.specialPlaceIncreaseRate>0){
                                this.billData.Increase=1;
                            }else{
                                this.billData.Increase=0;
                            }
                            if(jddata.citySubsidy==4){
                                this.billData.cityFixedSubsidy = jddata.cityFixedSubsidy;
                            }
                            if(jddata.diffCitySubsidy==4){
                                this.billData.diffCityFixedSubsidy = jddata.diffCityFixedSubsidy;
                            }
                        }else{
                            this.billData.citySubsidy=jddata.citySubsidy;
                            this.billData.diffCitySubsidy=jddata.diffCitySubsidy;
                            this.billData.isHolidayHasOvertimeSetting=jddata.isHolidayHasOvertimeSetting;
                            this.billData.isTaxIncluded=jddata.isTaxIncluded;
                            this.billData.isWeekendHasOvertimeSetting=jddata.isWeekendHasOvertimeSetting;
                            this.billData.isWorkdayHasOvertimeSetting=jddata.isWorkdayHasOvertimeSetting;
                            this.billData.specialPlace=jddata.specialPlace;
                            this.billData.specialPlaceIncreaseRate=jddata.specialPlaceIncreaseRate;
                            this.billConfiguration.workdayDepartHourPrice=jddata.workdayDepartHourPrice; //工作日小时 出发 价格，必填
                            this.billConfiguration.workdayWorkHourPrice=jddata.workdayWorkHourPrice;//工作日小时 工作时价格，//必填
                            this.billConfiguration.workdayBackHourPrice=jddata.workdayBackHourPrice; //工作日小时 返回 价格，必填
                            this.billConfiguration.weekendDepartHourPrice=jddata.weekendDepartHourPrice; //周末小时 出发 价格，必填
                            this.billConfiguration.weekendWorkHourPrice=jddata.weekendWorkHourPrice;//周末小时 工作时价格，//必填
                            this.billConfiguration.weekendBackHourPrice=jddata.weekendBackHourPrice; //周末小时 返回 价格，必填
                            this.billConfiguration.holidayDepartHourPrice=jddata.holidayDepartHourPrice; //节假日小时 出发 价格，必填
                            this.billConfiguration.holidayWorkHourPrice=jddata.holidayWorkHourPrice;//节假日小时 工作时价格，//必填
                            this.billConfiguration.holidayBackHourPrice=jddata.holidayBackHourPrice; //节假日小时 返回 价格，必填
                            this.billConfiguration.isDeductOneHourPrice=jddata.isDeductOneHourPrice;//是否扣除1小时价格设置
                            if(this.billConfiguration.isDeductOneHourPrice){
                                this.billConfiguration.deductionOneHourBTime = jddata.deductionOneHourBTime;
                                this.billConfiguration.deductionOneHourETime = jddata.deductionOneHourETime;
                            }
                            if(jddata.specialPlaceIncreaseRate>0){
                                this.billData.Increase=1;
                            }else{
                                this.billData.Increase=0;
                            }
                            if(jddata.citySubsidy==4){
                                this.billData.cityFixedSubsidy = jddata.cityFixedSubsidy;
                            }
                            if(jddata.diffCitySubsidy==4){
                                this.billData.diffCityFixedSubsidy = jddata.diffCityFixedSubsidy;
                            }
                        }
                        this.specialArea = jddata.specialPlace;
                        //工作日加班
                        if (this.billData.isWorkdayHasOvertimeSetting) {
                            this.billData.workdayOverTimeBefore = jddata.workdayOverTimeBefore;
                            this.billData.workdayOverTimeAfter = jddata.workdayOverTimeAfter;
                            this.billData.workdayOverTimeHourPrice = jddata.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if (this.billData.isWeekendHasOvertimeSetting) {
                            this.billData.weekendOverTimeBefore = jddata.weekendOverTimeBefore;
                            this.billData.weekendOverTimeAfter = jddata.weekendOverTimeAfter;
                            this.billData.weekendOverTimeHourPrice = jddata.weekendOverTimeHourPrice;
                        }
                        if (this.billData.isHolidayHasOvertimeSetting) {
                            this.billData.holidayOverTimeBefore = jddata.holidayOverTimeBefore;
                            this.billData.holidayOverTimeAfter = jddata.holidayOverTimeAfter;
                            this.billData.holidayOverTimeHourPrice = jddata.holidayOverTimeHourPrice;
                        }
                        if (this.billData.citySubsidy == 4) {
                            this.billData.cityFixedSubsidy = jddata.cityFixedSubsidy;
                        }
                    }
                    this.billData.settleType=param;
                    if(this.curentType==param){
                        let param2=JSON.parse(window.localStorage.getItem('billData2'));
                        let param3=JSON.parse(window.localStorage.getItem('billConfiguration2'));
                        if(param2||param3){
                            this.billData=param2;
                            this.billConfiguration=param3;
                            this.specialArea =param2.specialPlace;
                        }else{
                            if(this.isedit!=1){
                                this.getareList();
                            }
                        }
                    }else{
                        window.localStorage.removeItem('billData2')
                        window.localStorage.removeItem('billConfiguration2')
                        if(this.isedit!=1){
                            this.getareList();
                        }
                    }

                }else{
                    this.acttab=4;
                    window.localStorage.setItem('billData2',JSON.stringify(this.billData))
                    window.localStorage.setItem('billConfiguration2',JSON.stringify(this.billConfiguration))
                    this.reassign();
                }

            },
            //确认添加特殊地址
            confirmDistrict(){
                let nodes=this.$refs.cascader.getCheckedNodes();
                let node=nodes[0];
                if(node && node.level==1){
                    //选择只有省
                    this.specialArea = this.specialArea.filter(item => {
                        if (item.provinceId != node.value) {
                            return true
                        }
                    })
                    let obj={
                        provinceId:node.value,
                        provinceName:node.label,
                        cityId:0,
                        cityName:'',
                    }
                    this.specialArea.push(obj);
                }
                if (node && node.level==2) {
                    //选择有省和市
                    let obj={
                        provinceId:node.parent.value,
                        provinceName:node.parent.label,
                        cityId:node.value,
                        cityName:node.label,
                    }
                    for (var i = 0; i < this.specialArea.length; i++) {
                        if (this.specialArea[i].provinceId == node.parent.value && this.specialArea[i].cityId == '') {
                            this.specialArea.splice(i, 1); //如果已经有省，则删除省
                        }
                        if (this.specialArea[i].cityId == node.value) {
                            this.specialArea.splice(i, 1); //如果已经有市，则删除市
                        }
                    }
                    this.specialArea.push(obj);
                }
                this.$refs.cascader.clearCheckedNodes();
                this.isShowCascader=false;
            },
            //删除特殊地址
            removeDistrict(index) {
                this.specialArea.splice(index, 1);
            },
            removecer(index){
                this.matchConfig.certificates.splice(index, 1);
            },
            pageInit(){
                //获取省列表
                getSpecialAreas().then(r=>{
                    if(r.Result==1){
                        let list=r.Data || [];
                        list.map(item=>{
                            item['label']=item.areaName;
                            item['value']=item.aid;
                        })
                        this.province=list;
                    }
                })
            },
            getCerTypes(){
                selectCerTypes().then((res)=> {
                    if (res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.cerList=res.Data;
                })
            },
            confirmCer(){
                if (this.CertificateTypes) {
                    const selectedItem = this.cerList.find((item) => {
                        return item.id === this.CertificateTypes
                    })
                    let obj = {
                        certificateId: selectedItem.id,
                        certificateName: selectedItem.name
                    }
                    this.matchConfig.certificates.push(obj);
                    const arr = this.matchConfig.certificates;
                    for(var i=0;i<arr.length;i++){
                        for(var j=i+1;j<arr.length;j++){
                            if(arr[i].certificateId == arr[j].certificateId){
                                arr.splice(j,1);
                                j--;
                                this.$message.warning("请勿重复添加证书");
                                return
                            }
                        }
                    }
                    this.matchConfig.certificates = arr;
                    this.isShowCertificate = false;
                } else {
                    this.$message.warning("请选择证书")
                }
            },
            openaddCer(){
                this.isShowCertificate=true;
                this.getCerTypes();
                this.CertificateTypes = '';
            },
            async queryDetail(){
                this.loading=true;
                let res = await getoffterDetail(this.offerid)
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                let data  = res.Data.serviceOffer;
                this.getdropList(0,0,false);
                this.getdropList(1,data.productDomainId,false);
                this.getdropList(2,data.oneProductId,false);
                this.getdropList(3,data.twoProductId,false);
                this.serviceOffer = data;
                this.changeTyoenone();
                this.selectStage();
                // console.log( this.serviceOffer)
                this.billData.settleType= res.Data.settleType || 0;
                if(this.serviceOffer.serviceType==1){
                    if(res.Data.settleType==0){
                        const fddata = res.Data.dailySettlement.billConfiguration;
                        // 按天 接单weekendWorkHourPrice
                        this.billData.citySubsidy = fddata.citySubsidy;
                        this.billData.diffCitySubsidy = fddata.diffCitySubsidy;
                        this.billData.holidayPrice = fddata.holidayPrice;
                        this.billData.isHolidayHasOvertimeSetting = fddata.isHolidayHasOvertimeSetting;
                        this.billData.isTaxIncluded = fddata.isTaxIncluded;
                        this.billData.isWeekendHasOvertimeSetting = fddata.isWeekendHasOvertimeSetting;
                        this.billData.isWorkdayHasOvertimeSetting=fddata.isWorkdayHasOvertimeSetting;
                        this.billData.specialPlace = fddata.specialPlace;
                        this.billData.specialPlaceIncreaseRate = fddata.specialPlaceIncreaseRate;
                        this.billData.vipHolidayPrice = fddata.vipHolidayPrice;
                        this.billData.vipWeekendPrice = fddata.vipWeekendPrice;
                        this.billData.vipWorkdayPrice = fddata.vipWorkdayPrice;
                        this.billData.workdayPrice = fddata.workdayPrice;
                        this.billData.weekendPrice = fddata.weekendPrice;
                        this.specialArea = fddata.specialPlace;
                        //工作日加班
                        if(this.billData.isWorkdayHasOvertimeSetting){
                            this.billData.workdayOverTimeBefore = fddata.workdayOverTimeBefore;
                            this.billData.workdayOverTimeAfter = fddata.workdayOverTimeAfter ;
                            this.billData.workdayOverTimeHourPrice= fddata.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if(this.billData.isWeekendHasOvertimeSetting){
                            this.billData.weekendOverTimeBefore = fddata.weekendOverTimeBefore;
                            this.billData.weekendOverTimeAfter = fddata.weekendOverTimeAfter;
                            this.billData.weekendOverTimeHourPrice = fddata.weekendOverTimeHourPrice;
                        }
                        if(this.billData.isHolidayHasOvertimeSetting){
                            this.billData.holidayOverTimeBefore = fddata.holidayOverTimeBefore;
                            this.billData.holidayOverTimeAfter = fddata.holidayOverTimeAfter;
                            this.billData.holidayOverTimeHourPrice = fddata.holidayOverTimeHourPrice;
                        }
                        if(this.billData.citySubsidy==4){
                            this.billData.cityFixedSubsidy = fddata.cityFixedSubsidy;
                        }
                        if(this.billData.diffCitySubsidy==4){
                            this.billData.diffCityFixedSubsidy = fddata.diffCityFixedSubsidy;
                        }
                        if(fddata.specialPlaceIncreaseRate>0){
                            this.billData.Increase=1;
                        }else{
                            this.billData.Increase=0;
                        }
                        //接单 每天
                        window.localStorage.setItem('jddata',JSON.stringify(res.Data.dailySettlement.orderTakingConfiguration));
                        // 发单
                        // this.fddata = res.Data.dailySettlement.billConfiguration;
                        // this.jddata = res.Data.dailySettlement.orderTakingConfiguration;
                    }else{
                        const fddata = res.Data.hourlySettlement.billConfiguration;
                        // this.jddata = res.Data.hourlySettlement.orderTakingConfiguration;
                        this.billData.citySubsidy=fddata.citySubsidy;
                        this.billData.diffCitySubsidy=fddata.diffCitySubsidy;
                        this.billData.isHolidayHasOvertimeSetting=fddata.isHolidayHasOvertimeSetting;
                        this.billData.isTaxIncluded=fddata.isTaxIncluded;
                        this.billData.isWeekendHasOvertimeSetting=fddata.isWeekendHasOvertimeSetting;
                        this.billData.isWorkdayHasOvertimeSetting=fddata.isWorkdayHasOvertimeSetting;
                        this.billData.specialPlace=fddata.specialPlace;
                        this.billData.specialPlaceIncreaseRate=fddata.specialPlaceIncreaseRate;
                        this.billConfiguration.workdayDepartHourPrice=fddata.workdayDepartHourPrice; //工作日小时 出发 价格，必填
                        this.billConfiguration.workdayWorkHourPrice=fddata.workdayWorkHourPrice;//工作日小时 工作时价格，//必填
                        this.billConfiguration.workdayBackHourPrice=fddata.workdayBackHourPrice; //工作日小时 返回 价格，必填
                        this.billConfiguration.vipWorkdayDepartHourPrice=fddata.vipWorkdayDepartHourPrice; //vip工作日小时 出发 价格，必填
                        this.billConfiguration.vipWorkdayWorkHourPrice=fddata.vipWorkdayWorkHourPrice;//vip工作日小时 工作时价格，//必填
                        this.billConfiguration.vipWorkdayBackHourPrice=fddata.vipWorkdayBackHourPrice; //vip工作日小时 返回 价格，必填
                        this.billConfiguration.weekendDepartHourPrice=fddata.weekendDepartHourPrice; //周末小时 出发 价格，必填
                        this.billConfiguration.weekendWorkHourPrice=fddata.weekendWorkHourPrice;//周末小时 工作时价格，//必填
                        this.billConfiguration.weekendBackHourPrice=fddata.weekendBackHourPrice; //周末小时 返回 价格，必填
                        this.billConfiguration.vipWeekendDepartHourPrice=fddata.vipWeekendDepartHourPrice; //vip周末小时 出发 价格，必填
                        this.billConfiguration.vipWeekendWorkHourPrice=fddata.vipWeekendWorkHourPrice;//vip周末小时 工作时价格，//必填
                        this.billConfiguration.vipWeekendBackHourPrice=fddata.vipWeekendBackHourPrice; //vip周末小时 返回 价格，必填
                        this.billConfiguration.holidayDepartHourPrice=fddata.holidayDepartHourPrice; //节假日小时 出发 价格，必填
                        this.billConfiguration.holidayWorkHourPrice=fddata.holidayWorkHourPrice;//节假日小时 工作时价格，//必填
                        this.billConfiguration.holidayBackHourPrice=fddata.holidayBackHourPrice; //节假日小时 返回 价格，必填
                        this.billConfiguration.vipHolidayDepartHourPrice=fddata.vipHolidayDepartHourPrice; //vip节假日小时 出发 价格，必填
                        this.billConfiguration.vipHolidayWorkHourPrice=fddata.vipHolidayWorkHourPrice;//vip节假日小时 工作时价格，//必填
                        this.billConfiguration.vipHolidayBackHourPrice=fddata.vipHolidayBackHourPrice; //vip节假日小时 返回 价格，必填
                        this.billConfiguration.isDeductOneHourPrice=fddata.isDeductOneHourPrice;//是否扣除1小时价格设置
                        this.specialArea = fddata.specialPlace;
                        // 是否扣除1小时
                        if(this.billConfiguration.isDeductOneHourPrice){
                            this.billConfiguration.deductionOneHourBTime = fddata.deductionOneHourBTime;
                            this.billConfiguration.deductionOneHourETime = fddata.deductionOneHourETime;
                        }
                        //工作日加班
                        if(this.billData.isWorkdayHasOvertimeSetting){
                            this.billData.workdayOverTimeBefore = fddata.workdayOverTimeBefore;
                            this.billData.workdayOverTimeAfter = fddata.workdayOverTimeAfter ;
                            this.billData.workdayOverTimeHourPrice= fddata.workdayOverTimeHourPrice;
                        }
                        //周末加班
                        if(this.billData.isWeekendHasOvertimeSetting){
                            this.billData.weekendOverTimeBefore = fddata.weekendOverTimeBefore;
                            this.billData.weekendOverTimeAfter = fddata.weekendOverTimeAfter;
                            this.billData.weekendOverTimeHourPrice = fddata.weekendOverTimeHourPrice;
                        }
                        if(this.billData.isHolidayHasOvertimeSetting){
                            this.billData.holidayOverTimeBefore = fddata.holidayOverTimeBefore;
                            this.billData.holidayOverTimeAfter = fddata.holidayOverTimeAfter;
                            this.billData.holidayOverTimeHourPrice = fddata.holidayOverTimeHourPrice;
                        }
                        if(this.billData.citySubsidy==4){
                            this.billData.cityFixedSubsidy = fddata.cityFixedSubsidy;
                        }
                        if(this.billData.diffCitySubsidy==4){
                            this.billData.diffCityFixedSubsidy = fddata.diffCityFixedSubsidy;
                        }
                        if(fddata.specialPlaceIncreaseRate>0){
                            this.billData.Increase=1;
                        }else{
                            this.billData.Increase=0;
                        }
                        window.localStorage.setItem('jddata',JSON.stringify(res.Data.hourlySettlement.orderTakingConfiguration));
                    }
                }
                this.specialInfos = res.Data.specialInfos || [];
                let arr = res.Data.specialInfos || [];
                for(let i=0;i<arr.length;i++) {
                    let arr2 =arr[i].problemOptions;
                    if(arr[i].problemType==1) {
                        this.$set(arr[i],'rddiocurrentOption','')
                        // this.checkradio['checkradio'+arr[i].sortNo]='';
                    }
                    if(arr[i].problemType==2) {
                        this.$set(arr[i],'currentOption', [])
                        // this.checkboxList[arr[i].sortNo]=[];
                    }
                    for(let i2=0;i2<arr2.length;i2++) {
                        if(arr2[i2].isChecked){
                            if(arr[i].problemType==2){
                                // this.checkboxList[arr[i].sortNo].push(arr2[i2].sortNo)
                                arr[i].currentOption.push(arr2[i2].sortNo);
                            }
                            if(arr[i].problemType==1){
                                // this.checkradio['checkradio'+arr[i].sortNo]=arr2[i2].sortNo;
                                arr[i].rddiocurrentOption=arr2[i2].sortNo;
                            }

                        }
                    }
                }
                // console.log("this.specialInfos",this.specialInfos)
                this.confirmInfos = res.Data.confirmInfos || [];
                let arr2 = res.Data.confirmInfos || [];
                for(let i2=0;i2<arr2.length;i2++) {
                    let arr3 = arr2[i2].subsets
                    for (let i3 = 0; i3 < arr3.length; i3++) {
                        let arr4 = arr3[i3].subsetContents;
                        for (let i4 = 0; i4 < arr4.length; i4++) {
                            let arr5 = arr4[i4].problemOptions;
                        if(arr4[i4].problemType==1){
                            this.$set(arr4[i4],'rddiocurrentOption','')
                        }
                        if(arr4[i4].problemType==2){
                            this.$set(arr4[i4],'currentOption', [])
                        }
                        for(let i5=0;i5<arr5.length;i5++){
                            if(arr5[i5].isChecked){
                                if(arr4[i4].problemType==1){
                                    arr4[i4].rddiocurrentOption=arr5[i5].sortNo;
                                }
                                if(arr4[i4].problemType==2){
                                    arr4[i4].currentOption.push(arr5[i5].sortNo);
                                }
                            }
                        }
                     }
                    }
                }
                this.matchConfig = res.Data.matchConfig;
                if(res.Data.matchConfig.certificates==null||!res.Data.matchConfig.certificates){
                    this.matchConfig.certificates=[]
                }
                if(res.Data.matchConfig.isOriginAuthRequired == null || !res.Data.matchConfig.isOriginAuthRequired) {
                    this.matchConfig.isOriginAuthRequired = 0
                }
                if(res.Data.matchConfig.isProductBrandPractical == null || !res.Data.matchConfig.isProductBrandPractical) {
                    this.matchConfig.isProductBrandPractical = 0
                }
                if(res.Data.matchConfig.isServiceLabelPractical == null || !res.Data.matchConfig.isServiceLabelPractical) {
                    this.matchConfig.isServiceLabelPractical = 0
                }
                if(res.Data.matchConfig.productBrandAuthType == null || !res.Data.matchConfig.productBrandAuthType) {
                    this.matchConfig.productBrandAuthType = 0
                }
                if(res.Data.matchConfig.serviceLabelAuthType == null || !res.Data.matchConfig.serviceLabelAuthType) {
                    this.matchConfig.serviceLabelAuthType = 0
                }
                setTimeout(()=>{
                    this.loading=false;
                },1000)
            },
            async getareList(){
                let res = await getSpecialAreaList()
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.specialArea=res.Data;
            }
        },
        created() {
            // this.getdropList(0,0);
            // this.pageInit();
            // this.specialArea = [];
            // let id = this.$route.query.id;
            // this.offerid = id;
            // let isedit = this.$route.query.isedit;
            // // debugger
            // if(id&&isedit==1) {
            //     this.queryDetail();
            // }else{
            //     this.reassign()
            //     this.getareList();
            // }
        },
        activated(){
            this.acttab=1;
            this.getdropList(0,0,false);
            this.pageInit();
            this.specialArea = [];
            let id = this.$route.query.id;
            this.offerid = id;
            let isedit = this.$route.query.isedit;
            this.isedit = isedit;
            this.receivedis=true;
            // this.receivedis=false;
            if(id&&isedit==1) {
                this.queryDetail();
            }else{
                this.serviceOffer= {
                    serviceName: '',//必传
                    productDomainId: '',//领域id,必传
                    oneProductId: '',//一级产品id,必传
                    twoProductId: '',//二级级产品id,必传
                    threeProductId: '',//三级产品id
                    serviceStageId: '',//服务类型id,必传
                    serviceType: 1,//类别，1-标准，2-项目,必传
                    content: ''//必传
                }
                this.specialInfos=[];
                this.confirmInfos=[
                    // {
                    //     moduleName:'',
                    //     subsets:[]
                    // }
                ];
                this.matchConfig={
                    serviceLabelAuthType: 0,//服务标签认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isServiceLabelPractical: 0,//服务标签是否需要实操认证 0-不需要，1-需要
                    productBrandAuthType: 0,//产品品牌认证类别,0-不需要，1-初级认证，2-中级认证，3-高级认证
                    isProductBrandPractical: 0,//产品品牌是否需要实操认证 0-不需要，1-需要
                    isOriginAuthRequired: 0,
                    certificates: []
                }
                window.localStorage.removeItem('serviceOffer')
                window.localStorage.removeItem('specialInfos')
                window.localStorage.removeItem('confirmInfos')
                window.localStorage.removeItem('billData')
                window.localStorage.removeItem('billConfiguration')
                window.localStorage.removeItem('billData2')
                window.localStorage.removeItem('billConfiguration2')
                window.localStorage.removeItem('jddata')
                this.reassign()
                this.getareList();
                this.changeTyoenone()
            }
        },
        destroyed() {
            window.localStorage.removeItem('serviceOffer')
            window.localStorage.removeItem('specialInfos')
            window.localStorage.removeItem('confirmInfos')
            window.localStorage.removeItem('billData')
            window.localStorage.removeItem('billConfiguration')
            window.localStorage.removeItem('billData2')
            window.localStorage.removeItem('billConfiguration2')
            this.reassign()
        },
    }
</script>

<style lang="scss">
    .step {
        position: relative;
        display: flex;
        margin-left: 10px;
        .red{
            color: #F75959!important;
        }
        .red2{
            background: #F75959!important;
        }
        .lx_step{
            display: flex;
            align-items: center;
            font-size: 20px;
            font-weight: 400;
            color: #999999;
        }
        .img_mar{
            margin-right:7px;
            img{
                vertical-align: middle;
            }
        }
        .line{
            width: 68px;
            height: 1px;
            background: #E5E5E5;
            position: relative;
            margin: 0px 11px;
        }
    }
    .content{
        position: relative;
        margin: 60px 80px 0px 0px;
        .font-20{
            font-size: 20px!important;
        }
        .our-button{
            width: 100px;
            height: 30px;
            background: #2D8CEF;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 24px;
            padding:0!important;
            border-radius: 0px!important;
        }
        .mar-l-43{
            margin-left: 43px;
        }
        .our-button2{
            border: 1px solid #2D8CEF;
            color: #2D8CEF;
        }
        .our-button3{
            border: 1px solid #F75959;
            color: #F75959;
        }
        .flex{
            display: flex;
        }
        .mar-l-129{
            margin-left: 129px;
        }
        .el-our-class{
            .el-form-item__error{
                padding-top: 2px!important;
            }
            .el-form-item__content{
                margin-left: 120px;
                font-size: 16px!important;
                color: #666666;
            }
            .el-form-item__label{
                font-size: 16px!important;
                font-weight: 400;
                color: #666666;
                text-align: center;
            }
            .el-input__inner{
                font-size: 16px!important;
                color: #333333;
                height: 38px!important;
            }
            .el-textarea__inner{
                height: 221px!important;
                font-size: 16px!important;
                color: #333333;
            }
        }
        .pos-absoulte{
            text-align: right;
            .el-button+.el-button{
                margin-left: 20px!important;
            }
            .el-button--mini, .el-button--mini.is-round{
                padding: 8px 15px!important;
            }
        }
        .special_content_max{
            position: relative;
            top:24px;
            padding: 30px 0;
            margin-bottom: 30px;
            .icon_close{
                font-size: 20px;
                position: absolute;
                right: 21px;
                color: #666666;
                top: 18px;
                cursor: pointer;
            }
        }
        .max_move{
            position: absolute;
            right: 55px;
            top: 18px;
        }
        .oper_con{
            line-height: 38px;
            margin-left: 20px;
            display: inline-flex;
            .speiclButton{
                border: none;
                background: #F5F7F9;
                width: 22px;
                padding: 0px;
            }
            img{
                vertical-align: middle;
                margin-right: 17px;
                cursor: pointer;
            }
        }
        .special_content{
            position: relative;
            top:24px;
            padding: 30px 0;
            margin-bottom: 30px;
            .max_icon_close{
                right: 430px!important;
                color: #666666!important;
                top: 38px!important;
            }
            .icon_close{
                font-size: 20px;
                position: absolute;
                right: 21px;
                color: #666666;
                top: 18px;
                cursor: pointer;
            }
            .single{
                display: flex;
                /*margin-bottom: 20px;*/
                .s-title{
                    text-align: center;
                    line-height: 38px;
                    width: 84px;
                }
                .width_550{
                    width: 550px;
                    margin-bottom: 20px;
                }
                .el-checkbox__input{
                    margin-left: 40px;
                }
                .el-radio__inner{
                    margin-left: 40px;
                }
                .el-radio__label{
                    padding-left: 30px!important;
                }
                .el-checkbox__label{
                    padding-left: 30px!important;
                }
                .el-textarea__inner{
                    width: 550px;
                    height: 115px;
                    margin-left: 80px;
                    margin-bottom: 20px;
                }
            }
            .el-input__inner{
                font-size: 16px!important;
                color: #333333;
                height: 38px!important;
                width: 550px;
            }
            .bottom_con{
                 margin-left: 80px;
                .add_btn{
                    width: 68px;
                    height: 26px;
                    border: 1px solid #2D8CEF;
                    font-size: 26px;
                    color: #2D8CEF;
                    line-height: 26px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
        .subset{
            display: flex;
            align-items: center;
            .subset-title{
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                line-height: 24px;
            }
            .subset-right{
                margin-left: 111px;
            }
            .el-button+.el-button{
                margin-left: 20px;
            }
            .width_550{
                width: 550px;
            }
        }
        .subset2{
            padding: 10px;
            position: relative;
            .sub-close{
                right: 430px!important;
                top: 38px!important;
            }
            .flex{
                display: flex;
            }
            .zj-btn{
                margin: 10px 0 10px 80px;
            }
            .subset-title{
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                line-height: 40px;
            }
            .subset-right{
                margin-left: 111px;
            }
            .el-button+.el-button{
                margin-left: 20px;
            }
            .width_550{
                width: 550px;
            }
        }
        .addZJ{
            width: 1124px;
            height: 50px;
            background: #F5F7F9;
            text-align: center;
            line-height: 50px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #2D8CEF;
            position: relative;
            cursor: pointer;
            margin-top: 10px;
        }
        .mar-b-30{
            margin-bottom: 30px;
        }
        .bill{
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            padding-left: 14px;
            .el-form-item__label{
                text-align: left;
            }
            .el-radio__input{
                vertical-align: top;
            }
            .el-input{
                width: 144px;
                margin-right: 18px;
            }
            .el-input__inner{
                width: 144px;
                height: 38px;
            }
            .d_flex{
                display: flex;
                align-items: center;
                height: 40px;
            }
            .mar-r-45{
                margin-right: 45px;
            }
            .flex_50{
                display: flex;
                .el-form-item{
                    width: 50%;
                }
            }
            .mar-r-40{
                margin-right: 40px;
            }
        }
        .area-item{
            position: relative;
            display: inline-block;
            vertical-align: middle;
            line-height: 26px;
            background-color: rgba(45, 140, 239, 0.4);
            margin-right: 26px;
            color: #2D8CEF;
            /*width: 68px;*/
            padding: 0px 20px;
            height: 26px;
            text-align: center;
            font-size: 14px;
            &:hover{
                cursor: pointer;
                .icon-remove{
                    display: block;
                }
            }
            .icon-remove{
                position: absolute;
                right: 0;
                top: 0;
                width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                font-size: 14px;
                color: #fff;
                cursor: pointer;
                display: none;
            }
        }
        .btn-add{
            position: relative;
            display: inline-block;
            vertical-align: middle;
            width: 68px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            border: 1px solid #2D8CEF;;
            background-color: #fff;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 16px;
            color: #2D8CEF;
            &:hover{
                background-color: #2D8CEF;
                color: #fff;
            }
        }
        .mar-r-22{
            margin-right:22px;
        }
    }
</style>
